
import { API_URLS } from "../../constants/apiUrls";
import { commonFetch } from "../commonFetch";
import configAPI from "../config";

export const getUserProfile = async () => {
  return commonFetch(API_URLS.GET_USER_PROFILE_APIURL, {
    method: "GET",
    requiresAuth: true,
  });
};

export const AddStudent = async () => {
  return commonFetch(API_URLS.ADD_STUDENT_APIURL, {
    method: "GET",
    requiresAuth: true,
  });
};

export const checkSessionAPI = async () => {
  return commonFetch(API_URLS.ADMIN_AREA_APIURL, {
    method: "GET",
    requiresAuth: true
  });
};

export const refreshTokenAPI = async (refPayload) => {
  return commonFetch(API_URLS.REFRESH_COMMON_TOKEN_API, {
    method: "POST",
    body: refPayload,
    requiresAuth: true
  });
};

export const getAllSchoolMappedClases = async (payload) => {
  return commonFetch(API_URLS.GET_ALL_SCHOOL_MAPPED_CLASSES, {
    method: "POST",
    body: payload,
    requiresAuth: true
  });
};

export const getAllStreamMasterTable = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_ALL_STREAM_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const getAllSubStreamsMasterTable = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_ALL_SUB_STREAM_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const getAllSubjectsMasterTable = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_ALL_SUBJECT_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true,
  });
};
export const getAllSubjectsMaster = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_ALL_SUBJECT_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true,
  });
};
export const getAllClassMasterTable = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_ALL_CLASS_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const getAllMasterClassMasterTable = async (formData) => {
  return commonFetch(`${API_URLS.GET_ALL_MASTER_CLASS_MASTERTABLE}`, {
    method: "POST",
    requiresAuth: true,
    body: formData,
  });
};

export const getAllClassSectionMasterTable = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_ALL_CLASS_SECTION_MASTERTABLE}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const updateStreamMasterTable = async (payload) => {
  return commonFetch(API_URLS.UPDATE_STREAM_MASTERTABLE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const addStreamMasterTable = async (payload) => {
  return commonFetch(API_URLS.ADD_STREAM_MASTERTABLE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};
export const updateSubStreamMasterTable = async (payload) => {
  return commonFetch(API_URLS.UPDATE_SUB_STREAM_MASTERTABLE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const addSubStreamMasterTable = async (payload) => {
  return commonFetch(API_URLS.ADD_SUB_STREAM_MASTERTABLE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};
export const updateSubjectMasterTable = async (payload) => {
  return commonFetch(API_URLS.UPDATE_SUBJECT_MASTERTABLE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const getAllCBSESubjectType = async () => {
  return commonFetch(`${API_URLS.GET_ALL_CBSE_SUBJECT_TYPE}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getAllExamComponent = async () => {
  return commonFetch(`${API_URLS.GET_ALL_EXAM_COMPONENT}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getAllResultType = async () => {
  return commonFetch(`${API_URLS.GET_ALL_RESULT_TYPE}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const addSubjectMasterTable = async (payload) => {
  return commonFetch(API_URLS.ADD_SUBJECT_MASTERTABLE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};
export const updateClassMasterTable = async (payload) => {
  return commonFetch(API_URLS.UPDATE_CLASS_MASTERTABLE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const addClassMasterTable = async (payload) => {
  return commonFetch(API_URLS.ADD_CLASS_MASTERTABLE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};
export const updateSectionMasterTable = async (payload) => {
  return commonFetch(API_URLS.UPDATE_SECTION_MASTERTABLE, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const addSectionMasterTable = async (payload) => {
  return commonFetch(API_URLS.ADD_SECTION_MASTERTABLE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};

export const deleteSectionById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_SECTION_MASTERTABLE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};
export const deleteClassById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_Class_MASTERTABLE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};
export const deleteStreamById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_STREAM_MASTERTABLE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};
export const deleteSubStreamById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_SUBSTREAM_MASTERTABLE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};
export const deleteSubjectById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_SUBJECT_MASTERTABLE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};

export const getAllPeriodTable = async (schoolID) => {
  return commonFetch(`${API_URLS.GETALL_PERIOD_APIURL}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const addPeriodTable = async (payload) => {
  return commonFetch(API_URLS.CREATE_PERIOD_APIURL, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};


export const updatePeriodTable = async (payload) => {

  const formData = new FormData();

  Object.keys(payload).forEach(key => {
    formData.append(key, payload[key]);
  });

  return commonFetch(API_URLS.UPDATEPERIOD_APIURL, {
    method: 'PUT',
    headers: {
    },
    body: formData,
    requiresAuth: true,
  });
};


export const deletePeriodById = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_PERIOD_TABLE}`, {
    method: 'DELETE',
    headers: {

    },
    body: formData,
    requiresAuth: true,
  });
};

// export const addStudentAttendenceMark = async (payload) => {
//   return commonFetch(API_URLS.ADD_STUDENTATTENDENCEMARK_APIURL, {
//     method: 'POST',
//     body: payload,
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     requiresAuth: true,
//   });
// };
export const addStudentAttendenceMark = async (payload) => {
  return commonFetch(API_URLS.ADD_STUDENTATTENDENCEMARK_APIURL, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};

export const UpdateStudentAttendenceMark = async (formData) => {
  return commonFetch(API_URLS.UPDATE_STUDENTATTENDENCEMARK_APIURL, {
    method: 'PUT',
    body: formData,

    requiresAuth: true,
  });
};

export const InsertUpdateStudentAttendance = async (formData) => {
  return commonFetch(API_URLS.INSERT_UPDATE_ATTENDANCE_STUDENT, {
    method: 'POST',
    body: formData,

    requiresAuth: true,
  });
};
export const UpdateStudentAttendenceMarkTeacher = async (payload) => {
  return commonFetch(API_URLS.UPDATE_STUDENTATTENDENCEMARK_APIURL, {
    method: 'PUT',
    body: payload,
    requiresAuth: true,
  });
};

export const getAllStudentAttendenceMark = async (formData) => {
  return commonFetch(API_URLS.GETALL_STUDENTATTENDENCEMARK_APIURL,
    {
      method: "POST",
      body: formData,
      requiresAuth: true
    });
};

export const getAllStuentsAttendanceReport = async (formData) => {
  return commonFetch(API_URLS.GETALL_STUDENTATTENDENCEMARKLIST_APIURL,
    {
      method: "POST",
      body: formData,
      requiresAuth: true
    });
};

export const getAllStudentAttendenceMarkByDate = async (formData) => {
  return commonFetch(API_URLS.GETALL_STUDENT_ATTENDANCE_BYDATE,
    {
      method: "POST",
      body: formData,
      requiresAuth: true
    });
};


export const classTeacherList = async (payload) => {

  const formData = new FormData();

  Object.keys(payload).forEach(key => {
    formData.append(key, payload[key]);
  });

  return commonFetch(API_URLS.UPDATEPERIOD_APIURL, {
    method: 'PUT',
    headers: {
    },
    body: formData,
    requiresAuth: true,
  });
};



// export const UpdateClassTeacher = async (payload) => {
//   return commonFetch(API_URLS.ADD_CLASSTEACHER_ASSINED_CLASS_SECTION_APIURL, {
//     method: 'POST',
//     body: payload,
//     headers: {

//     },
//     requiresAuth: true,
//   });
// };

export const getAllTeacher = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_TEACHER_APIURL}/${schoolID}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getAllClassSectionTeacher = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_TEACHER_ASSIGNED_CLASS_SECTION_LIST_APIURL}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`, {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const InsertClassTeacher = async (payload) => {
  return commonFetch(API_URLS.ADD_CLASSTEACHER_ASSINED_CLASS_SECTION_APIURL, {
    method: 'POST',
    body: payload,
    headers: {

    },
    requiresAuth: true,
  });
};

export const updateClassTeacher = async (payload) => {
  return commonFetch(API_URLS.UPDATE_CLASSTEACHER_ASSINED_CLASS_SECTION_APIURL, {
    method: "POST",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true,
  });
};

export const deleteClassTeacherById = async (id) => {
  if (!id) throw new Error("Invalid ID for delete");

  return commonFetch(
    `${API_URLS.DELETE_TEACHER_ASSIGNED_CLASS_SECTION_APIURL}/Id?ID=${id}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      requiresAuth: true,
    });
};

export const addFeeType = async (payload) => {
  return commonFetch(API_URLS.ADD_FEETYPE_APIURL, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const deleteFeeType = async (id) => {
  return commonFetch(`${API_URLS.DELETE_FEETYPE_APIURL}/${id}`, {
    method: 'DELETE',
    requiresAuth: true,
  });
};

export const getAllFeeType = async (SchoolID) => {
  return commonFetch(`${API_URLS.GETALL_FEETYPE_APIURL}?schoolId=${SchoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const updateFeeType = async (id, payload) => {
  return commonFetch(`${API_URLS.UPDATE_FEETYPE_APIURL}/${id}`, {
    method: 'PUT',
    body: payload,
    requiresAuth: true,
  });
};

export const addFeeFrequency = async (payload) => {
  return commonFetch(API_URLS.ADD_FEEFREQUENCY_APIURL, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const deleteFeeFrequency = async (id) => {
  return commonFetch(`${API_URLS.DELETE_FEEFREQUENCY_APIURL}/${id}`, {
    method: "DELETE",
    requiresAuth: true,
  });
};

export const getAllFeeFrequency = async (SchoolID) => {
  return commonFetch(`${API_URLS.GETALL_FEEFREQUENCY_APIURL}?schoolId=${SchoolID}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const updateFeeFrequency = async (id, payload) => {
  return commonFetch(`${API_URLS.UPDATE_FEEFREQUENCY_APIURL}/${id}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};



export const getFeetypeList = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_FEE_TYPE_APIURL}?schoolId=${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const getFeeFrequencyList = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ALL_FEE_FREQUENCY_APIURL}?schoolId=${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};


export const getFeeFrequencyDueDateListList = async (formData) => {
  return commonFetch(API_URLS.GET_ALL_FEE_FREQUENCY_DUEDATES_APIURL, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};


export const SubmitFeeStrutureAssignToClass = async (formData) => {
  return commonFetch(`${API_URLS.ADD_FEE_STRUCTURE_TO_CLASS_APIURL}`, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const CreateFeeStrutureAssignToClass = async (formData) => {
  return commonFetch(`${API_URLS.CREATE_FEE_STRUCTURE_TO_CLASS_APIURL}`, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const UpdateFeeStrutureAssignToClass = async (classID, formData) => {
  return commonFetch(`${API_URLS.UPDATE_FEE_STRUCTURE_TO_CLASS_APIURL}/${classID}`, {
    method: "PUT",
    body: formData,
    requiresAuth: true
  });
};


export const DeleteFeeStrutureAssignToClass = async (schoolID, classID, payload) => {
  return commonFetch(`${API_URLS.DELETE_FEE_STRUCTURE_TO_CLASS_APIURL}/${schoolID}/${classID}`, {
    method: "DELETE",
    body: payload,
    requiresAuth: true,
  });
};

export const NoticeGetAllRoles = async () => {
  return commonFetch(API_URLS.NOTICE_GET_ALL_ROLES, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getAllRoles = async () => {
  return commonFetch(API_URLS.GET_ALL_ROLES, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getAllMenuList = async () => {
  return commonFetch(API_URLS.GET_ALL_MENU_LIST, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getInsertAndUpdateRoleRoute = async (payload) => {
  return commonFetch(API_URLS.GET_INSERT_AND_UPDATE_ROLE_ROUTE, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};



export const getRouteDetailByRoleId = async (roleId, schoolId) => {
  return commonFetch(`${API_URLS.GET_ROUTE_DETAIL_BY_ROLE_ID}?RoleId=${roleId}&SchoolID=${schoolId}`, {
    method: "GET",
    requiresAuth: true,
  });
};



export const AdminGetAllRoles = async () => {
  const url = `${API_URLS.ADMIN_GET_ALL_ROLES}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};


export const CommunicationMessageAllSent = async (schoolID, academicYearID, pageNumber, pageSize) => {
  const url = `${API_URLS.COMMUNICATION_MESSAGE_ALL_SENT}?schoolId=${schoolID}&AcademicYearID=${academicYearID}&PageNumber=${pageNumber}&PageSize=${pageSize}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};


export const AdminCommunicationMessage = async (payload) => {
  if (!payload.schoolID) {
    throw new Error("schoolID is required in the payload");
  }
  const url = `${API_URLS.ADMIN_COMMUNICATION_MESSAGE}`;
  return commonFetch(url, {
    method: "POST",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true,
  });
};


export const AddNoticeByRole = async (payload) => {
  return commonFetch(API_URLS.ADD_NOTICE_BY_ROLE, {
    method: "POST",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true,
  });
};

export const UpdateNoticeByRole = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_NOTICE_BY_ROLE}/?schoolId=${payload.schoolId}`, {
    method: "PUT",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true
  });
};

export const DeleteNoticeBoard = async (payload) => {
  const url = `${API_URLS.DELETE_NOTICE_BY_ROLE}`
  return commonFetch(url, {
    method: "DELETE",
    requiresAuth: true,
    body: payload
  }
  );
};

export const RoleNoticeDetailsByNoticeId = async (schoolID) => {
  const url = `${API_URLS.ROLE_NOTIFICATION_BY_NOTICEID}?schoolId=${schoolID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const AllNoticeList = async (schoolID, academicYearID) => {
  const url = `${API_URLS.ALL_NOTICE_LIST}?schoolId=${schoolID}&AcademicYearID=${academicYearID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetNoticeCategorylist = async (schoolID) => {
  const url = `${API_URLS.GET_NOTICE_CATEGORY_LIST}`;
  // const url = `${API_URLS.GET_NOTICE_CATEGORY_LIST}?schoolId=${schoolID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};
// 
// export const getAllFeesCollectionList = async (schoolId) => {
//   return commonFetch(`${API_URLS.GETALL_FEECOLLECTION_APIURL}?schoolId=${schoolId}`, {
//     method: "POST",
//     requiresAuth: true
//   });
// };

export const SidebarConfigurationGetAllLabel = async (schoolID, payload) => {
  return commonFetch(`${API_URLS.SIDEBAR_CONFIGURATION_GET_ALL_LABEL}/${schoolID}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const SidebarConfigurationInsertOrUpdate = async (schoolID, payload) => {
  return commonFetch(`${API_URLS.SIDEBAR_CONFIGURATION_INSERT_OR_UPDATE}/${schoolID}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};



export const getAllFeesCollectionList = async (schoolId, body = {}) => {
  return commonFetch(
    `${API_URLS.GETALL_FEECOLLECTION_APIURL}/${schoolId}`,
    {
      method: "POST",
      body: body,
      headers: {
        "Content-Type": "application/json"
      },
      requiresAuth: true
    }
  );
};

export const UpdateAllFeesCollection = async (payload) => {
  if (!payload.schoolID) {
    throw new Error("schoolID is required in the payload");
  }

  const url = `${API_URLS.UPDATE_ALL_FEE_COLLECTION_APIURL}/${payload.schoolID}`;

  return commonFetch(url, {
    method: "POST",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true,
  });
};

export const getFeesCollectionList = async (schoolId, body = {}) => {
  return commonFetch(
    `${API_URLS.GET_ALL_FEE_COLLECTION_APIURL}/${schoolId}`,
    {
      method: "POST",
      body: body,
      headers: {
        "Content-Type": "application/json"
      },
      requiresAuth: true
    }
  );
};



export const getAllColletionStatusList = async (payload) => {
  return commonFetch(API_URLS.GET_ALL_COLLECTION_STATUS_LIST,
    {
      method: "POST",
      requiresAuth: true,
      body: payload,
    }
  );
};

export const getAllColletionListSummeryList = async (payload) => {
  return commonFetch(API_URLS.GET_FEE_COLLECT_LIST_SUMMERY,
    {
      method: "POST",
      requiresAuth: true,
      body: payload,
    }
  );
};

export const DeleteFeesCollectionById = async (payload, schoolId) => {
  return commonFetch(
    `${API_URLS.DELETE_FEE_COLLECTION_BY_ID_APIURL}/${schoolId}`,
    {
      method: "DELETE",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const getAllFeesColletionCheckStatusList = async (schoolId, studentId) => {
  return commonFetch(
    `${API_URLS.GET_ALL_FEES_VIEW_COLLECTION_CHECK_STATUS_LIST}?schoolId=${schoolId}&studentId=${studentId}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getQRCodeFeesColletionCheckStatusList = async (payload) => {
  return commonFetch(API_URLS.GET_QRCODE_FEES_VIEW_COLLECTION_CHECK_STATUS_LIST,
    {
      method: "POST",
      requiresAuth: true,
      body: payload,
    }
  );
};


export const getAllFeeDetailsByStudentID = async (schoolId, studentId, academicYearId) => {
  return commonFetch(
    `${API_URLS.GET_ALL_STUDENT_FEE_DETAILS_LIST}?StudentID=${studentId}&SchoolID=${schoolId}&AcademicYearID=${academicYearId}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getAllQrCodeFeeDetailsByStudentID = async (schoolId, studentId, academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_STUDENT_FEE_QRCODE_DETAILS_LIST}?StudentID=${studentId}&SchoolID=${schoolId}&AcademicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};



export const getInvoiceByFeeCollectId = async (payload) => {
  return commonFetch(API_URLS.GET_INVOICE_BY_FEE_COLLECT_ID,
    {
      method: "POST",
      requiresAuth: true,
      body: payload,
    }
  );
};

// export const StudentSubjectList = async ({ schoolID, studentID, classID }) => {
//   const url = `${API_URLS.STUDENT_SUBJECT_LIST}?schoolId=${schoolID}&studentId=${studentID}&classId=${classID}`;
//   return commonFetch(url, {
//     method: "GET",
//     requiresAuth: true,
//   });
// };


export const GetAllCalenderData = async (payload) => {
  return commonFetch(API_URLS.GET_ALL_CALENDER_DATA, {
    method: "POST",
    body: payload,
    requiresAuth: true
  });
};

export const GetAllSideBarUpdatedMenu = async (schoolID, payload) => {
  if (!schoolID) {
    throw new Error("schoolID is required to fetch sidebar menu");
  }
  return commonFetch(`${API_URLS.SIDEBAR_UPDATEDMENU}/${schoolID}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getLogoBase64Post = async (payload) => {
 return commonFetch(`${API_URLS.GET_LOGO_BASE64POST}`, {
    method: "POST",  
     body:payload,
    requiresAuth: true,
  });
};

export const GetCreateticket = async (payload) => {
 return commonFetch(`${API_URLS.CREATE_TICKET_SUPPORT}`, {
    method: "POST",  
     body:payload,
    requiresAuth: true,
  });
};

export const getAllTickets = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_TICKETS_SUPPORT}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getStaffDetails = async (schoolID, employeeID) => {
  return commonFetch(
    `${API_URLS.GET_STAFF_DETAILS}/${schoolID}/${employeeID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const GetChangePassword = async (payload) => {
 return commonFetch(`${API_URLS.GET_EMPLOYEE_CHANGE_PASSWORD}`, {
    method: "POST",  
     body:payload,
    requiresAuth: true,
  });
};


export const getStudentReportCard = async (studentID, schoolID, academicYearID, classID, sectionID, streamID, subStreamID) => {

  const formData = new FormData();

  if (studentID) formData.append("StudentID", studentID);
  if (schoolID) formData.append("SchoolID", schoolID);
  if (academicYearID) formData.append("AcademicYearID", academicYearID);
  if (classID) formData.append("ClassID", classID);
  if (sectionID) formData.append("SectionID", sectionID);
  if (streamID) formData.append("StreamID", streamID);
  if (subStreamID) formData.append("SubStreamID", subStreamID);
  formData.append("TemplateID", "");

  return commonFetch(API_URLS.GET_STUDENT_MARKSHEETS, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const GetStudentReportCardMarksheetSettingWise = async (studentID, schoolID, academicYearID, classID, sectionID, streamID, subStreamID) => {

  const formData = new FormData();

  if (studentID) formData.append("StudentID", studentID);
  if (schoolID) formData.append("SchoolID", schoolID);
  if (academicYearID) formData.append("AcademicYearID", academicYearID);
  if (classID) formData.append("ClassID", classID);
  if (sectionID) formData.append("SectionID", sectionID);
  if (streamID) formData.append("StreamID", streamID);
  if (subStreamID) formData.append("SubStreamID", subStreamID);
  formData.append("TemplateID", "");

  return commonFetch(API_URLS.GET_STUDENT_RESULT_REPORT_CARD_MARKSHEET_SETTING_WISE, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

// export const getStudentReportCard = async (studentID, schoolID, classID, sectionID) => {
//   return commonFetch(
//     `${API_URLS.GET_STUDENT_MARKSHEETS}?studentID=${studentID}&schoolID=${schoolID}&classID=${classID}&sectionID=${sectionID}`,
//     {
//       method: "GET",
//       requiresAuth: true,
//     }
//   );
// };

export const createExam = async (payload) => {
  return commonFetch(`${API_URLS.CREATE_EXAM}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getExamList = async (schoolID, academicYearID, term) => {

  const params = new URLSearchParams({
    SchoolId: schoolID,
    AcademicYearId: academicYearID,
  });

  if (term) {
    params.append("Term", term);
  }

  return commonFetch(
    `${API_URLS.GET_EXAM_LIST}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const GetExamListMapping = async (schoolID, academicYearID, term) => {

  const params = new URLSearchParams({
    SchoolId: schoolID,
    AcademicYearId: academicYearID,
  });

  if (term) {
    params.append("Term", term);
  }

  return commonFetch(
    `${API_URLS.GET_EXAM_LIST}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const updateExam = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_EXAM}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const deleteExamDetails = async (payload) => {
  return commonFetch(`${API_URLS.DELETE_EXAM_DETAILS}`, {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const createHoliday = async (payload) => {
  return commonFetch(`${API_URLS. CREATE_HOLIDAY}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};


export const updateHoliday = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_HOLIDAY}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllLeaveMasterTypes = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_LEAVE_MASTER_TYPES}/${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const addLeaveMasterType = async (payload) => {
  return commonFetch(API_URLS.ADD_LEAVE_MASTER_TYPES, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    requiresAuth: true,
  });
};

export const updateLeaveMasterTypes = async (payload) => {
  return commonFetch(API_URLS.UPDATE_LEAVE_MASTER_TYPES, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const deleteLeaveMasterTypes = async (leaveTypeID , formData) => {
  return commonFetch(`${API_URLS.DELETE_LEAVE_MASTER_TYPES}/${leaveTypeID}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};

export const getStaffLeaveByEmployee = async (schoolID,employeeID, academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_STAFF_LEAVE_BY_EMPLOYEE}/${employeeID}?schoolid=${schoolID}&academicYearID=${academicYearID}`,
    
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const AddStaffLeave = async (payload) => {
  return commonFetch(API_URLS.ADD_STAFF_LEAVE, {
    method: 'POST',
    body: payload,
 
    requiresAuth: true,
  });
};

export const updateStaffLeave = async (payload) => {
  return commonFetch(API_URLS.UPDATE_STAFF_LEAVE, {
    method: 'PUT',

    body: payload,
    requiresAuth: true,
  });
};

export const deleteStaffLeave = async (payload) => {
  return commonFetch(API_URLS.DELETE_STAFF_LEAVE, {
    method: 'DELETE',
    body: payload,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};

export const getAllEmpolyeeLeaveData = async (payload) => {
  return commonFetch(API_URLS.GET_ALL_EMPLOYEE_LEAVE_DATA,
    {
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};
export const getAllStudentLeaveData = async (payload) => {
  return commonFetch(API_URLS.GET_ALL_STUDENT_LEAVE_DATA,
    {
      body: payload,
      method: "POST",
      requiresAuth: true,
    }
  );
};

export const UpdateLeaveRequestByAdmin = async (payload) => {
  return commonFetch(API_URLS.APPROVE_LEAVE_REQUEST_BY_ADMIN, {
    method: 'POST',
    body: payload,
 
    requiresAuth: true,
  });
};


export const DeleteStudentEmployeeLeave = async (payload) => {
  return commonFetch(API_URLS.DELETE_STUDENT_EMPLOYEE_LEAVE, {
    method: 'DELETE',
    body: payload,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};

export const getStudentLeaveData = async (schoolID, studentID,academicYearID) => {
  return commonFetch(`${API_URLS.GET_STUDENT_LEAVE_DATA}?schoolId=${schoolID}&studentId=${studentID}&academicYearID=${academicYearID}`, {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const AddStudentLeave = async (payload) => {
  return commonFetch(API_URLS.STUDENT_APPLY_LEAVE, {
    method: 'POST',
    body: payload,
 
    requiresAuth: true,
  });
};

export const updateStudentLeave = async (payload) => {
  return commonFetch(API_URLS.UPDATE_LEAVE_BY_STUDENT, {
    method: 'PUT',
    body: payload,
    requiresAuth: true,
  });
};

export const deleteStudentLeave = async (payload) => {
  return commonFetch(API_URLS.DELETE_LEAVE_BY_STUDENT, {
    method: 'DELETE',
    body: payload,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};


export const ApproveLeaveRequestByTeacher = async (payload) => {
  return commonFetch(API_URLS.APPROVE_LEAVE_REQUEST_BY_TEACHER, {
    method: 'POST',
    body: payload,
 
    requiresAuth: true,
  });
};


export const DeleteStudentLeave = async (payload) => {
  return commonFetch(API_URLS.DELETE_STUDENT_LEAVE, {
    method: 'DELETE',
    body: payload,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};
export const getAllEmployeeAttendaceList = async (payload) => {
  return commonFetch(API_URLS.GET_ALL_EMPLOYEE_ATTENDANCE_LIST,
    {
      method: "Post",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const markEmployeeAttendance = async (payload) => {
  return commonFetch(`${API_URLS.MARK_EMPLOYEE_ATTENDANCE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const updateEmployeeAttendance = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_EMPLOYEE_ATTENDANCE}/`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const staffPunchInPunchOut = async (payload) => {
  return commonFetch(`${API_URLS.STAFF_PUNCHIN_PUNCHOUT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  }); 
};

export const getEmployeeAttendaceReportList = async (schoolID ,academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_EMPLOYEE_ATTENDANCE_REPORT_LIST}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const createExamSchedule = async (payload) => {
  return commonFetch(`${API_URLS.CREATE_EXAM_SCHEDULE}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
    requiresAuth: true,
  });
};

export const getExamScheduleByClass = async (payload) => {
  
  return commonFetch(`${API_URLS.GET_EXAM_SCHEDULE_BY_CLASS}`,{
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};


export const updateExamSchedule = async (payload) => {
  return commonFetch(API_URLS.UPDATE_EXAM_SCHEDULE, {
    method: "PUT",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true
  });
};

export const deleteExamScheduleDetail = async (payload) => {
  const url = `${API_URLS.DELETE_EXAM_SCHEDULE_DETAIL}`
  return commonFetch(url, {
    method: "DELETE",
    requiresAuth: true,
    body: payload
  });
};

export const getAllHolidays = async (schoolID,academicYearID) => {
  return commonFetch(
    `${API_URLS.GETALL_HOLIDAY}?schoolId=${schoolID}&academicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const DeleteHolidays = async (payload) => {
  return commonFetch(API_URLS.DELETE_HOLIDAY, {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const addUpdateExamMarks = async (payload) => {
  return commonFetch(`${API_URLS.ADD_UPDATE_EXAM_MARKS}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getExamMarksByClass = async (payload) => {
  return commonFetch(
    `${API_URLS.GET_EXAM_MARKS_BY_CLASS}`,
    {
      method: "Post",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const GetExamReportResultdata = async (payload) => {
  return commonFetch(`${API_URLS.GET_EXAM_RESULT_REPORT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  
  });
};


export const GetStudentHomeworkDashboardData = async (studentID, classId, sectionID, academicYearID) => {
  const params = new URLSearchParams();

  if (studentID) params.append("StudentID", studentID);
  if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (classId) params.append("ClassID", classId);
  if (sectionID) params.append("SectionID", sectionID);

  return commonFetch(
    `${API_URLS.GET_STUDENT_HOMEWORKDASHBOARD_DATA}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
 
    }
  );
};

export const GetStudentTimetable = async (studentID, classId,streamID, SubstreamID, sectionID,schoolID,academicYearID, dayName) => {
  const params = new URLSearchParams();

  if (studentID) params.append("StudentID", studentID);
  if (classId) params.append("ClassID", classId);
  if (streamID) params.append("StreamID", streamID);
  if (SubstreamID) params.append("SubStreamID", SubstreamID);
  if (sectionID) params.append("SectionID", sectionID);
  if (schoolID) params.append("SchoolID", schoolID);
  if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (dayName) params.append("DayName", dayName);

  return commonFetch(`${API_URLS.GET_TIMETABLE_STUDENTDASHBOARD}?${params.toString()}`, {
    method: "GET",
    requiresAuth: true,
  
  });
};

export const GetClassWiseFeeReport = async (SchoolID,academicYearID, ClassId, FeeFrequencyId, FromDate, ToDate) => {
  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolID", SchoolID);
  if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (ClassId) params.append("ClassId", ClassId);
  if (FeeFrequencyId) params.append("FeeFrequencyId", FeeFrequencyId);
  if (FromDate) params.append("FromDate", FromDate);
  if (ToDate) params.append("ToDate", ToDate);

  return commonFetch(`${API_URLS.GET_CLASS_WISE_FEE_REPORT}?${params.toString()}`, {
    method: "GET",
    requiresAuth: true,
  });
};


export const GetClassWiseFeeReportSummery = async ({
  SchoolID,
  academicYearID ,
  ClassId,
  StreamId,
  FeeFrequencyId,
  FromDate,
  ToDate,
}) => {
  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolID", SchoolID);
  if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (ClassId) params.append("ClassId", ClassId);
  if (StreamId) params.append("StreamId", StreamId);
  if (FeeFrequencyId) params.append("FeeFrequencyId", FeeFrequencyId);
  if (FromDate) params.append("FromDate", FromDate);
  if (ToDate) params.append("ToDate", ToDate);

  return commonFetch(
    `${API_URLS.GET_CLASS_WISE_FEE_REPORT_SUMMERY}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

// export const GetStudentTimetable = async (studentID, classId, sectionID,schoolID) => {
//   return commonFetch(
//     `${API_URLS.GET_TIMETABLE_STUDENTDASHBOARD}?StudentID=${studentID}&ClassID=${classId}&SectionID=${sectionID}&schoolID=${schoolID}`,
//     {
//       method: "GET",
//       requiresAuth: true,
//     }
//   );
// };

export const getTodayClasses = async (employeeID,schoolID,academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_TODAY_CLASSES_FOR_TEACHER}?TeacherID=${employeeID}&SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,
    
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const getBirthdayReminder = async (employeeID,schoolID , academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_BIRTHDAY_REMINDER_FOR_TEACHER}?TeacherID=${employeeID}&SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,
    
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const examStatusUpdate = async (payload) => {
  return commonFetch(`${API_URLS.EXAM_STATUS_UPDATE}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};


export const GetAllBusRouteList = async (schoolID, AcademicYearID, pageNumber = 1, pageSize = 100) => {
  return commonFetch(
    `${API_URLS.GET_ALL_BUS_ROUTE_LIST}?SchoolID=${schoolID}&AcademicYearID=${AcademicYearID}&PageNumber=${pageNumber}&PageSize=${pageSize}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const InsertBusRoute = async (formdata) => {
  return commonFetch(`${API_URLS.INSERT_BUS_ROUTE}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const UpdateBusRoute = async (formdata) => {
  return commonFetch(`${API_URLS.UPDATE_BUS_ROUTE}`, {
    method: "PUT",
    body: formdata,
    requiresAuth: true,
  });
};

export const DeleteBusRoute = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_BUS_ROUTE}`, {
    method: 'DELETE',
    body: formData,
    headers: {
      // Do NOT set Content-Type; browser handles FormData automatically
    },
    requiresAuth: true,
  });
};

export const UpdateBusRouteStatus = async (formdata) => {
  return commonFetch(`${API_URLS.UPDATE_ROUTE_STATUS}`, {
    method: "PUT",
    body: formdata,
    requiresAuth: true,
  });
};

export const getAllBusRouteList = async (schoolID, academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_BUS_ROUTE_LIST}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,  
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getAllDriverList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_DRIVER_LIST}?SchoolID=${schoolID}`,  
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getAllHelperList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_HELPER_LIST}?SchoolID=${schoolID}`,  
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const insertVehicleDetails = async (payload) => {
  return commonFetch(`${API_URLS.INSERT_VEHICLE_DETAILS}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  
  });
};

export const updateVehicleDetails = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_VEHICLE_DETAILS}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllVechileList = async (schoolID, academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_VECHICLE_LIST}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,  
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getVehicleMasterList = async (schoolID, academicYearID) => {
  return commonFetch(
    `${API_URLS.TRANSPORT_MANAGEMENT_VECHICLE_MASTER_GET_LIST}`,  
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const deleteVechileList = async (payload) => {
  return commonFetch(API_URLS.DELETE_VECHICLE_LIST, {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const vechileStatusUpdate = async (payload) => {
  return commonFetch(`${API_URLS.STATUS_TOGGLE_VECHICLE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};


//Gate Pass Master Service
export const ExitGateMasterPost = async (payload) => {
  return commonFetch(`${API_URLS.EXIT_GATE_MASTER_POST}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllGatePass = async (schoolID,PageNumber,PageSize) => {
  return commonFetch(
    `${API_URLS.EXIT_GATE_MASTER_GET}?SchoolID=${schoolID}&PageNumber=${PageNumber}&PageSize=${PageSize}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const updateGatePass = async (gateID,payload) => {
  return commonFetch(`${API_URLS.EXIT_GATE_MASTER_PUT}${gateID}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const deleteGetPass = async (gateID,schoolID) => {
  return commonFetch(`${API_URLS.EXIT_GATE_MASTER_DELETE}${gateID}?SchoolID=${schoolID}`, {
    method: 'DELETE',
    requiresAuth: true,
  });
};


//Visit Purpose Service

export const AddVisitPurpose = async (payload) => {
  return commonFetch(`${API_URLS.ADD_VISIT_PURPOSE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllPurpose = async (schoolID,PageNumber,PageSize) => {
  return commonFetch(
    `${API_URLS.GET_VISIT_PURPOSE}?SchoolID=${schoolID}&PageNumber=${PageNumber}&PageSize=${PageSize}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const updateVisitPurpose = async (purposeID,payload) => {
  return commonFetch(`${API_URLS.UPDATE_VISIT_PURPOSE}${purposeID}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const deleteVisitPurpose = async (purposeID,schoolID) => {
  return commonFetch(`${API_URLS.DELETE_VISIT_PURPOSE}${purposeID}?SchoolID=${schoolID}`, {
    method: 'DELETE',
    requiresAuth: true,
  });
}

// Marks & Grading API
export const divisionSaveUpdate = async (payload) => {
  return commonFetch(`${API_URLS.DIVISION_MASTER_SAVE_UPDATE_DIVISION}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllDivisionList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.DIVISION_MASTER_GET_ALL_DIVISION_LIST}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const updateDivisionList = async (purposeID,payload) => {
  return commonFetch(`${API_URLS.DIVISION_MASTER_DIVISION_STATUS_UPDATE}${purposeID}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const percentageRemarkSaveUpdate = async (payload) => {
  return commonFetch(`${API_URLS.DIVISION_MASTER_SAVE_UPDATE_PERCENTAGE_REMARK}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getAllPercentageRemarkList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.DIVISION_MASTER_GET_ALL_PRECENTAGE_REMARK_LIST}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const percentageRemarkUpdate = async (payload) => {
  return commonFetch(`${API_URLS.DIVISION_MASTER_UPDATE_PRECENTAGE_REMARK}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const subjectGradeRangeSaveUpdate = async (payload) => {
  return commonFetch(`${API_URLS.DIVISION_MASTER_SAVE_UPDATE_SUBJECT_GRADE_RANGE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getSubjectGradeRangeList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.DIVISION_MASTER_GET_ALL_SUBJECT_GRADE_LIST}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const subjectGradeRangeUpdate = async (payload) => {
  return commonFetch(`${API_URLS.DIVISION_MASTER_UPDATE_SUBJECT_GRADE_LIST}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetAllStudentTransportAllocation = async (formdata) => {
  return commonFetch(`${API_URLS.TRANSPORT_MANAGEMENT_ALL_ACTIONS}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const InsertStudentTransportAllocation = async (formdata) => {
  return commonFetch(`${API_URLS.TRANSPORT_MANAGEMENT_ALL_ACTIONS}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const UpdateStudentTransportAllocation = async (formdata) => {
  return commonFetch(`${API_URLS.TRANSPORT_MANAGEMENT_ALL_ACTIONS}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const DeleteStudentTransportAllocation = async (formdata) => {
  return commonFetch(`${API_URLS.TRANSPORT_MANAGEMENT_ALL_ACTIONS}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const GetAllVehicalListByAction = async (formdata) => {
  return commonFetch(`${API_URLS.TRANSPORT_MANAGEMENT_ALL_ACTIONS}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const StatusUpdateByAction = async (formdata) => {
  return commonFetch(`${API_URLS.TRANSPORT_MANAGEMENT_ALL_ACTIONS}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

//Gate Pass List 

export const InsertStudentGatePassList = async (formdata) => {
  return commonFetch(`${API_URLS.INSERT_STUDENT_GATEPASS_LIST}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const updateStudentGatePassList = async (formdata) => {
  return commonFetch(`${API_URLS.UPDATE_STUDENT_GATEPASS_LIST}`, {
    method: "PUT",
    body: formdata,
    requiresAuth: true,
  });
};

export const deleteStudentGatePassList = async (passID,schoolID,formdata) => {
  return commonFetch(`${API_URLS.DELETE_STUDENT_GATEPASS_LIST}${passID}/${schoolID}`, {
    method: 'DELETE',
     body: formdata,
    requiresAuth: true,
  });
}


export const GetStudentGatePassList = async (schoolID,payload) => {
  return commonFetch(`${API_URLS.GET_STUDENT_GATEPASS_LIST}${schoolID}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
 
export const InsertStaffGatePassList = async (formdata) => {
  return commonFetch(`${API_URLS.INSERT_STAFF_GATEPASS_LIST}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const updateStaffGatePassList = async (formdata) => {
  return commonFetch(`${API_URLS.UPDATE_STAFF_GATEPASS_LIST}`, {
    method: "PUT",
    body: formdata,
    requiresAuth: true,
  });
};

export const deleteStaffGatePassList = async (passID,schoolID,formdata) => {
  return commonFetch(`${API_URLS.DELETE_STAFF_GATEPASS_LIST}${passID}/${schoolID}`, {
    method: 'DELETE',
     body: formdata,
    requiresAuth: true,
  });
}


export const GetStaffGatePassList = async (schoolID,payload) => {
  return commonFetch(`${API_URLS.GET_STAFF_GATEPASS_LIST}${schoolID}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};



export const InsertVisitorGatePassList = async (formdata) => {
  return commonFetch(`${API_URLS.INSERT_VISITOR_GATEPASS_LIST}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const updateVisitorGatePassList = async (formdata) => {
  return commonFetch(`${API_URLS.UPDATE_VISITOR_GATEPASS_LIST}`, {
    method: "PUT",
    body: formdata,
    requiresAuth: true,
  });
};

export const deleteVisitorGatePassList = async (passID,schoolID,formdata) => {
  return commonFetch(`${API_URLS.DELETE_VISITOR_GATEPASS_LIST}${passID}/${schoolID}`, {
    method: 'DELETE',
     body: formdata,
    requiresAuth: true,
  });
}


export const GetVisitorGatePassList = async (schoolID,payload) => {
  return commonFetch(`${API_URLS.GET_VISITOR_GATEPASS_LIST}${schoolID}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

//Host Meeting

export const getAllMeetingList = async (payload) => {
  return commonFetch(
    `${API_URLS.CURD_ACTIONS_HOST_MEETING_LIST}`,
    {
      method: "POST",
    body: payload,
      requiresAuth: true,
    }
  );
};

export const InsertHostMeeting = async (payload) => {
  return commonFetch(`${API_URLS.CURD_ACTIONS_HOST_MEETING_LIST}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const UpdateHostMeeting = async (payload) => {
  return commonFetch(`${API_URLS.CURD_ACTIONS_HOST_MEETING_LIST}`, {
   method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const deleteHostMeeting = async (payload) => {
  return commonFetch(`${API_URLS.CURD_ACTIONS_HOST_MEETING_LIST}`, {
    method: "POST",
     body: payload,
    requiresAuth: true,
  });
}

export const TicketTrackingActions = async (payload) => {
  return commonFetch(`${API_URLS.TICKETS_TRACKING_ACTIONS}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const UpdateParentDetails = async (formdata) => {
  return commonFetch(`${API_URLS.UPDATE_PARENT_DETAILS}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const GetParentDetails = async (formdata) => {
  return commonFetch(`${API_URLS.GET_PARENT_DETAILS}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};


export const GetIDCardDetailsByRole = async ({
  roleID,
  schoolID,
  academicYearID,
  studentID,
  employeeID,
  classID,
  sectionID,
  streamID,
  subStreamID,
}) => {

  const formdata = {
    roleID: roleID ?? null,
    schoolID: schoolID ?? null,
    academicYearID: academicYearID ?? null,
    studentID: studentID ?? null,
    employeeID: employeeID ?? null,
    classID: classID ?? null,
    sectionID: sectionID ?? null,
    streamID: streamID ?? null,
    subStreamID: subStreamID ?? null,
  };


  return commonFetch(API_URLS.GET_ID_CARD_DETAILS_BY_ROLE, {
    method: "POST",
    requiresAuth: true,
  body: formdata,
  });
};


export const GetStudentFeeCollectionReport = async ({
  schoolID,
  academicYearID,
  feeTypeId,
  classId,
  SelectedDate,
  SelectedDateTo,

}) => {
  const params = new URLSearchParams();

  params.append("SchoolID", schoolID);
  if (academicYearID) params.append("AcademicYearId", academicYearID);
  if (feeTypeId) params.append("FeeTypeID", feeTypeId);
  // if (monthId) params.append("MonthID", monthId);
  if (classId) params.append("ClassID", classId);
  if (SelectedDate) params.append("SelectedDate", SelectedDate);
  if (SelectedDateTo) params.append("SelectedDateTo", SelectedDateTo);

  const url = `${API_URLS.GET_STUDENT_FEE_COLLECTION_REPORT}?${params.toString()}`;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetStudentFeeCollectionSummary = async (payload) => {
  const { SchoolID,academicYearID, ClassId, SectionId, FeeTypeId , SelectedDate,
  SelectedDateTo,} = payload;

  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolID", SchoolID);
  if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (ClassId) params.append("ClassId", ClassId);
  if (SectionId) params.append("SectionId", SectionId);
  if (FeeTypeId) params.append("FeeTypeId", FeeTypeId);
if (SelectedDate) params.append("SelectedDate", SelectedDate);
 if (SelectedDateTo) params.append("SelectdDateTo", SelectedDateTo);
  return commonFetch(
    `${API_URLS.GET_STUDENT_FEE_COLLECTION_SUMMARY}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const GetStudentFeeDueReport = async ({
  schoolID,
  feeTypeId,
  monthId,
  classId,
  academicYearID,
}) => {
  const params = new URLSearchParams();

  params.append("SchoolID", schoolID);
  if (feeTypeId) params.append("FeeTypeID", feeTypeId);
  if (monthId) params.append("MonthID", monthId);
  if (classId) params.append("ClassID", classId);
  if (academicYearID) params.append("AcademicYearID", academicYearID);

  const url = `${API_URLS.GET_STUDENT_FEE_DUE_REPORT}?${params.toString()}`;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};


export const GetStudentFeeDueSummary = async (payload) => {
  const params = new URLSearchParams();

  if (payload.SchoolID) params.append("SchoolID", payload.SchoolID);
  if (payload.classId) params.append("ClassID", payload.classId);
  if (payload.feeTypeId) params.append("FeeTypeID", payload.feeTypeId);
  if (payload.MonthId) params.append("MonthID", payload.MonthId);
  if (payload.academicYearID) params.append("AcademicYearID", payload.academicYearID);

  return commonFetch(
    `${API_URLS.GET_STUDENT_FEE_DUE_SUMMARY}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

//Status Master
export const InsertInquaryStatus = async (statusID, statusName,schoolID,isDefault) => {
  return commonFetch(
    `${API_URLS.INSERT_INQUIRY_STATUS}?StatusID=${statusID}&StatusName=${statusName}&SchoolID=${schoolID}&IsDefault=${isDefault}`,
    {
      method: "POST",
       
      requiresAuth: true,
    }
  );
};


export const GetInquaryStatus = async (schoolID, academicYearID) => {
  const url = `${API_URLS.GET_INQUIRY_STATUS}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const DeleteInquaryStatus = async (payload) => {
  return commonFetch(`${API_URLS.DELETE_INQUIRY_STATUS}`, {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
}


// Add inquiry
export const InsertInquiry = async (payload) => {

const params = new URLSearchParams();

if (payload.SchoolId) params.append("SchoolId", payload.SchoolId);
if (payload.AcademicYearID) params.append("AcademicYearID", payload.AcademicYearID);
if (payload.StudentName) params.append("StudentName", payload.StudentName);
if (payload.Email) params.append("Email", payload.Email);
if (payload.DOB) params.append("DOB", payload.DOB);
if (payload.ContactNo) params.append("ContactNo", payload.ContactNo);
if (payload.Gender) params.append("Gender", payload.Gender);
if (payload.AppliedClassId) params.append("AppliedClassId", payload.AppliedClassId);
if (payload.Category) params.append("Category", payload.Category);
if (payload.IsRTE) params.append("IsRTE", payload.IsRTE); 
if (payload.FatherName) params.append("FatherName", payload.FatherName);
if (payload.FatherMobile) params.append("FatherMobile", payload.FatherMobile);
if (payload.MotherName) params.append("MotherName", payload.MotherName);
if (payload.MotherMobile) params.append("MotherMobile", payload.MotherMobile);
if (payload.CreatedBy) params.append("CreatedBy", payload.CreatedBy);

const queryString = params.toString();

  return commonFetch(
    `${API_URLS.INSERT_INQUIRY}?${queryString}`,
    {
      method: "POST",
      requiresAuth: true,
    }
  );
};

export const GetAdmissionDetails = async (schoolID,enquiryID) => {
  const url = `${API_URLS.GET_ADMISSIONINQUIRY_DETAILS}?SchoolID=${schoolID}&EnquiryID=${enquiryID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetAdmissionList = async (schoolID, academicYearID) => {
  
  const url = `${API_URLS.GET_ADMISSIONINQUIRY_LIST}?SchoolId=${schoolID}&AcademicYearID=${academicYearID}`;
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const UpdateInquaryStatus = async (payload) => {
  const url = `${API_URLS.UPDATE_ADMISSIONINQUIRY_STATUS}`;
  return commonFetch(url, {
    method: "PUT",
    body:payload,
    requiresAuth: true,
  });
};

export const UpdateStudentEnqiuryDetails = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_STUDENT_ENQUIRY_DETAILS}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const UpdateAdmissionStatus = async (payload) => {
  const url = `${API_URLS.UPDATE_CONVERTTOADMISSION_STATUS}`;
  return commonFetch(url, {
    method: "PUT",
    body:payload,
    requiresAuth: true,
  });
};


export const PaymentGetWayData = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ROZAR_PAYMENT_GATEWAY_DATA}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const SaveUpdateSchoolPaymentGateway = async (formData, queryParams = {}) => {

  const queryString = new URLSearchParams();

  Object.keys(queryParams).forEach(key => {
    if (queryParams[key] !== null && queryParams[key] !== undefined) {
      queryString.append(key, queryParams[key]);
    }
  });
  
  const url = `${API_URLS.GET_ROZAR_PAYMENT_SAVE_UPDATE_GATEWAY}?${queryString.toString()}`;

  return commonFetch(
    url,
    {
      method: "POST",
      body: formData,
      requiresAuth: true,

    }
  );
};

export const getStudentAttendenceMarkByStudentId = async (SchoolID,StudentId, academicYearID) => {
  return commonFetch(
   `${API_URLS.GET_STUDENT_MY_ATTENDANCE_REPORT_BY_ID}?SchoolID=${SchoolID}&AcademicYearID=${academicYearID}&StudentID=${StudentId}`,
    {
      method: "GET",
      requiresAuth: true
    });
};


export const StudentBioMetricActions = async (formData) => {
  return commonFetch(
    `${API_URLS.BIOMETRIC_ALL_ACTIONS_FOR_STUDENT}`,
    {
      method: "POST",
      body: formData,
      requiresAuth: true,
    }
  );
};


export const EmpolyeeBioMetricActions = async (formData) => {
  return commonFetch(
    `${API_URLS.BIOMETRIC_ALL_ACTIONS_FOR_EMPLOYEE}`,
    {
      method: "POST",
      body: formData,
      requiresAuth: true,
    }
  );
};

export const GetAllDevicesForSchools = async (formData) => {
  return commonFetch(
    `${API_URLS.GET_ALL_DEVICES_FOR_SCHOOL}`,
    {
      method: "POST",
      body: formData,
      requiresAuth: true,
    }
  );
};

export const CreateUpdateDevicesForSchool = async (formData) => {
  return commonFetch(
    `${API_URLS.CREATE_UPDATE_DEVICE_FOR_SCHOOL}`,
    {
      method: "POST",
      body: formData,
      requiresAuth: true,
    }
  );
};

export const DeleteDevicesForSchool = async (formData) => {
  return commonFetch(
    `${API_URLS.DELETE_DEVICE_FOR_SCHOOL}`,
    {
      method: "POST",
      body: formData,
      requiresAuth: true,
    }
  );
};

export const UpdateFeeParentPaymentRecipt = async (formBody) => {
  return commonFetch(
    `${API_URLS.UPDATE_FEE_PAYMENT_BY_PARENT_APIURL}`,
    {
      method: "POST",
      body: formBody,
      requiresAuth: true,
    }
  );
};

export const GetStudentsFeeQrCodeDetails = async (payload) => {
  return commonFetch(API_URLS.GET_QRCODE_FEES_STUDENT_DETAILS_LIST, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const GetStudentsFeeQrCodeSummery = async (payload) => {
  return commonFetch(API_URLS.GET_QRCODE_FEES_STUDENT_SUMMERY_LIST, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const ApproveStudentsFeeQrCode = async (payload) => {
  return commonFetch(API_URLS.APPROVE_QRCODE_FEES_STUDENT, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const RejectStudentsFeeQrCode = async (payload) => {
  return commonFetch(API_URLS.REJECT_QRCODE_FEES_STUDENT, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const GetQrCodeFeeMasterList = async () => {
  return commonFetch(
    `${API_URLS.GET_QR_CODE_FEE_STATUS_MASTER}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const CreateFeeStudentSetting = async (formBody) => {
  return commonFetch(
    `${API_URLS.CREATE_STUDENT_FEE_SETTING}`,
    {
      method: "POST",
      body: formBody,
      requiresAuth: true,
    }
  );
};


export const addMasterDiscount = async (payload) => {
  return commonFetch(API_URLS.ADD_DISCOUNT_APIURL, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const deleteMasterDiscount = async (payload) => {
  return commonFetch(API_URLS.DELETE_DISCOUNT_APIURL, {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const getAllMasterDiscount = async (payload) => {
  return commonFetch(API_URLS.GETALL_DISCOUNT_APIURL, {
    method: "POST",
    body: payload,
    requiresAuth: true
  });
};

export const updateMasterDiscount = async (payload) => {
  return commonFetch(API_URLS.UPDATE_DISCOUNT_APIURL, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const GetStudentFeeStructureSetting = async (payload) => {
  return commonFetch(API_URLS.GET_STUDENT_FEE_STRUCTURE_SETTING, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};


export const getAllParents= async (SchoolID,academicYearID) => {
  return commonFetch(
   `${API_URLS.GET_ALL_PARENTS}?SchoolID=${SchoolID}&AcademicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true
    });
};

export const InsertUpdateHostelCreation = async (formdata) => {
  return commonFetch(`${API_URLS.INSERTUPDATEHOSTELCREATION}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const getAllHostellist= async (SchoolID,pagenumber,pagesize) => {
  return commonFetch(
   `${API_URLS.GETALLHOSTELLIST}?SchoolId=${SchoolID}&PageNumber=${pagenumber}&PageSize=${pagesize}`,
    {
      method: "GET",
      requiresAuth: true
    });
};

export const deleteHostel = async (hostelId,schoolId ,payload) => {
  return commonFetch(`${API_URLS.DELETEHOSTEL}?hostelId=${hostelId}&SchoolID=${schoolId}`,
    {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const InsertUpdateRoomTypeCreation = async (formdata) => {
  return commonFetch(`${API_URLS.ADDUPDATEROOMTYPE}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const getAllRoomTypeList= async (SchoolID,pagenumber,pagesize) => {
  return commonFetch(
   `${API_URLS.GETALLROOMTYPELIST}?SchoolId=${SchoolID}&PageNumber=${pagenumber}&PageSize=${pagesize}`,
    {
      method: "GET",
      requiresAuth: true
    });
};

export const DeleteRoomType = async (roomTypeId,schoolId ,payload) => {
  return commonFetch(`${API_URLS.DELETEROOMTYPE}?roomTypeId=${roomTypeId}&schoolID=${schoolId}`,
    {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const InsertUpdateHostelRoomCreation = async (formdata) => {
  return commonFetch(`${API_URLS.ADDUPDATEHOSTELROOM}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const getAllHostelRoomList= async (SchoolID,pagenumber,pagesize) => {
  return commonFetch(
   `${API_URLS.GETALLHOSTELROOMLIST}?SchoolId=${SchoolID}&PageNumber=${pagenumber}&PageSize=${pagesize}`,
    {
      method: "GET",
      requiresAuth: true
    });
};

export const getAllHostelRoom= async (SchoolID,pagenumber,pagesize) => {
  return commonFetch(
   `${API_URLS.GETALLHOSTELROOMLIST}?SchoolId=${SchoolID}&PageNumber=${pagenumber}&PageSize=${pagesize}`,
    {
      method: "GET",
      requiresAuth: true
    });
};

export const getAllHostelRoomForassign= async (SchoolID) => {
  return commonFetch(
   `${API_URLS.GETALLHOSTELROOMLIST}?SchoolId=${SchoolID}`,
    {
      method: "GET",
      requiresAuth: true
    });
};


export const DeleteHostelRoom = async (roomId,schoolId ,payload) => {
  return commonFetch(`${API_URLS.DELETEHOSTELROOM}?roomId=${roomId}&schoolID=${schoolId}`,
    {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const InsertUpdateHostelAssign = async (formdata) => {
  return commonFetch(`${API_URLS.ADDUPDATEASSIGNHOSTEL}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};
export const StatusUpdateHostelAssign = async (formdata) => {
  return commonFetch(`${API_URLS.STATUSUPDATEASSIGNHOSTEL}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const getAllHostelAssignlist = async (
  SchoolID,
  AcademicYearID,
  pagenumber,
  pagesize,
  searchtext,
  sortby
) => {
  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolId", SchoolID);
  if (AcademicYearID) params.append("AcademicYearID", AcademicYearID);
  if (pagenumber) params.append("PageNumber", pagenumber);
  if (pagesize) params.append("PageSize", pagesize);

  if (searchtext && searchtext.trim() !== "") {
    params.append("SearchText", searchtext);
  }

  if (sortby && sortby.trim() !== "") {
    params.append("SortBy", sortby);
  }

  return commonFetch(
    `${API_URLS.GETALLLISTASSIGNHOSTEL}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getAllHostelData= async (payload) => {
  return commonFetch(API_URLS.GETALLHOSTELDATA,
    {
      method: "POST",
      body: payload,
      requiresAuth: true
    });
};

export const DeleteHostelAssign = async (assignmentId,schoolId ,payload) => {
  return commonFetch(`${API_URLS.DELETEASSIGNHOSTEL}?assignmentId=${assignmentId}&schoolID=${schoolId}`,
    {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

//class master list
export const ClassMasterList= async () => {
  return commonFetch(
   `${API_URLS.CLASSMASTERLIST}`,
    {
      method: "GET",
      requiresAuth: true
    });
}


//CO-Scholastic  POINT 5 api

export const COScholasticsubjectGradeRangeSave = async (payload) => {
  return commonFetch(`${API_URLS.POST_COSCHOLASTIC_MARKS_GRADING_POINT_5}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const COScholasticgetSubjectGradeRangeListMaster = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_COSCHOLASTIC_MARKS_GRADING_POINT_5}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const COScholasticgetSubjectGradeRangeList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_COSCHOLASTIC_MARKS_GRADING_POINT_5}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const COScholasticsubjectGradeRangeUpdate = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_COSCHOLASTIC_MARKS_GRADING_POINT_5}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

//CO-Scholastic  POINT 3 api

export const COScholasticPoint3subjectgradingSave = async (payload) => {
  return commonFetch(`${API_URLS.POST_COSCHOLASTIC_MARKS_GRADING_POINT_3}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const COScholasticPoint3subjectgradingList = async (schoolID) => {
  return commonFetch(
    `${API_URLS.GET_COSCHOLASTIC_MARKS_GRADING_POINT_3}?SchoolID=${schoolID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const COScholasticPoint3subjectgradingUpdate = async (payload) => {
  return commonFetch(`${API_URLS.UPDATE_COSCHOLASTIC_MARKS_GRADING_POINT_3}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const addUpdateCoScholasticExam = async (payload) => {
  return commonFetch(`${API_URLS.ADD_UPDATE_CO_SCHOLASTIC_EXAM}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getCoScholasticExamMarksByClass = async (payload) => {
  return commonFetch(
    `${API_URLS.GET_CO_SCHOLASTIC_EXAM}`,
    {
      method: "Post",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const InsertBiometricAttendanceEmployee = async (payload) => {
  return commonFetch(
    `${API_URLS.BIOMETRIC_ATTENDANCE_UPPLOAD_EMPLOYEE}`,
    {
      method: "Post",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const InsertBiometricAttendanceStudent = async (payload) => {
  return commonFetch(
    `${API_URLS.BIOMETRIC_ATTENDANCE_UPPLOAD_STUDENT}`,
    {
      method: "Post",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const addMasterFine = async (payload) => {
  return commonFetch(API_URLS.ADD_Fine_APIURL, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};


export const deleteMasterFine = async (selectedDeleteId,schoolId ,adminID, payload) => {
  return commonFetch(`${API_URLS.DELETE_Fine_APIURL}/${selectedDeleteId}?schoolID=${schoolId}&deletedBy=${adminID}`,
    {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};


// export const getAllMasterFine = async (schoolID) => {
//   return commonFetch(
//     `${API_URLS.GETALL_Fine_APIURL}?SchoolID=${schoolID}`,
//     {
//       method: "GET",
//       requiresAuth: true,
//     }
//   );
// };
export const getAllMasterFine = async (schoolID, academicYear) => {
  return commonFetch(
    `${API_URLS.GETALL_Fine_APIURL}?schoolID=${schoolID}&academicYear=${academicYear}`, 
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const updateMasterFine = async (payload) => {
  return commonFetch(API_URLS.UPDATE_Fine_APIURL, {
    method: 'PUT',
    body: payload,
    requiresAuth: true,
  });
};

//Additional subject maaping authservice

export const insertupdateAdditionalSubject = async (payload) => {
  
  return commonFetch(`${API_URLS.INSERT_UPDATE_ADDITIONAL_SUBJECT}`,{
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};

// export const getAdditionalSubject = async (schoolID, academicYearID) => {
//   return commonFetch(`${API_URLS.GET_ADDITIONAL_SUBJECT}/${schoolID}/${academicYearID}`, {
//     method: "GET",
//     requiresAuth: true
//   });
// };
export const getAdditionalSubject = async (
  schoolID,
  academicYearID,
  pageNumber ,
  pageSize 
) => {
  return commonFetch(
    `${API_URLS.GET_ADDITIONAL_SUBJECT}/${schoolID}/${academicYearID}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const deleteAdditionalSubject = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_ADDITIONAL_SUBJECT}`, {
    method: 'DELETE',
    body: formData,
    // headers: {
    //   // Do NOT set Content-Type; browser handles FormData automatically
    // },
    requiresAuth: true,
  });
};

export const updateAdditionalSubject = async (formData) => {
  
  return commonFetch(`${API_URLS.UPDATE_ADDITIONAL_SUBJECT}`,{
      method: "POST",
      body: formData,
      requiresAuth: true,
    }
  );
};

export const getAdditionalSubjectList = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_ADDITIONAL_SUBJETlIST}?SchoolID=${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const getClassListBySubject = async (schoolID, subjectID, academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_CLASS_STREAM_SUBSTREAMBY_SUBJECT}?SchoolID=${schoolID}&SubjectID=${subjectID}&AcademicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


//Session setting auth service

export const insertupdateSessionYear = async (payload) => {
  
  return commonFetch(`${API_URLS.SESSION_INSERT_UPDATE_API}`,{
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const getSessionYearList = async (formData) => {
  return commonFetch(`${API_URLS.GET_SESSION_YEAR_LIST}`, {
    method: "POST",
     body: formData,
    requiresAuth: true
  });
};

export const getSessionYearById = async (schoolID, academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_SESSIONYEARBUID_LIST}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const deleteSessionYear = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_SESSION_YEAR}`, {
    method: 'DELETE',
    body: formData,
    // headers: {
    //   // Do NOT set Content-Type; browser handles FormData automatically
    // },
    requiresAuth: true,
  });
};

export const ToggleStatusOfSessionYear = async (formData) => {
  return commonFetch(API_URLS.SESSION_YEAR_TOGGLE_STATUS, {
    method: 'PUT',
    body: formData,

    requiresAuth: true,
  });
};


export const GetCoScholasticSubject = async (
  schoolID,
  acedemicyearID,
  classId,
  streamID,
  SubstreamID,
  sectionID,
  term
) => {
  const params = new URLSearchParams();

  if (schoolID) params.append("SchoolID", schoolID);
  if (acedemicyearID) params.append("AcademicYearID", acedemicyearID);
  if (classId) params.append("ClassID", classId);
  if (streamID) params.append("StreamID", streamID);
  if (SubstreamID) params.append("SubStreamID", SubstreamID);
  if (sectionID) params.append("SectionID", sectionID);
  if (term) params.append("Term", term); 

  return commonFetch(
    `${API_URLS.GET_COSCHOLASTIC_SUBJECT_DETAILS}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};



export const ExamMappinginsert = async (payload) => {
  
  return commonFetch(`${API_URLS.ADD_EXAM_MAPPING}`,{
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};
export const ExamMappingUpdate = async (payload) => {
  
  return commonFetch(`${API_URLS.UPDATE_EXAM_MAPPING}`,{
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};


export const getExamMappedList = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GETALL_EXAM_MAPPING}/${schoolID}?AcademicYearID=${academicYearID}`, {
    method: "GET",
    requiresAuth: true
  });
};


export const DeleteExamMapping = async (payload) => {
  return commonFetch(`${API_URLS.DELETE_EXAM_MAPPING}`,
    {
    method: 'DELETE',
    body: payload,
    requiresAuth: true,
  });
};

export const UpdateStudentFeeStructure = async (formData) => {
  return commonFetch(`${API_URLS.UPDATE_STUDENT_FEE_STRUCTURE}`, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const UpdateFeeStructureStatus = async (payload) => {
  return commonFetch(`${API_URLS.STATUS_FEE_STRUCTURE_SHOW}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
    requiresAuth: true
  });
};

export const getAllExamBulkUpdate = async (params) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== undefined && v !== "")
  );

  const query = new URLSearchParams(cleanParams).toString();

  return commonFetch(`Reports/bulk-exam-student-marks?${query}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const ExaminsertBulkUpdate = async (payload) => {
  
  return commonFetch(`${API_URLS.INSERT_MARK_BULK_UPDATE}`,{
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};
export const ExamUpdateMarksBulk = async (payload) => {
  
  return commonFetch(`${API_URLS.UPDATE_MARK_BULK_UPDATE}`,{
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const GetDayList = async () => {
  return commonFetch(`${API_URLS.GET_DAY_LIST}`, {
    method: "POST",
    requiresAuth: true
  });
};

export const AddCustomPeriod = async (payload) => {
  return commonFetch(API_URLS.ADD_CUSTOM_ADDPERIOD, {
    method: "POST",
    body: payload,
    requiresAuth: true
  });
};

export const AddSubjectPeriod = async (payload) => {
  return commonFetch(API_URLS.ADD_SUBJECT_PERIOD, {
    method: "POST",
    body: payload,
    requiresAuth: true
  });
};

export const deleteCustomPeriod= async (formData) => {
  return commonFetch(`${API_URLS.DELETE_CUSTOM_PERIOD}`, {
    method: 'DELETE',
    body: formData,
 
    requiresAuth: true,
  });
};

// export const getSchoolTimeTableList = async ({
//   schoolId,
//   classId,
//   employeeId,
//   isCustomPeriod ,
// }) => {
//   const params = new URLSearchParams();

//   if (schoolId) params.append("SchoolId", schoolId);
//   if (classId) params.append("ClassID", classId);
//   if (employeeId) params.append("EmployeeID", employeeId);
//   if (isCustomPeriod !== undefined)
//     params.append("IsCustomPeriod", isCustomPeriod);

//   return commonFetch(
//     `${API_URLS.GET_CUSTOM_TIMETABLE}?${params.toString()}`,
//     {
//       method: "GET",
//       requiresAuth: true,
//     }
//   );
// };
export const getSchoolTimeTableList = async ({
  schoolId,
  academicYearID,
  classId,
  employeeId,
  streamId,
  subStreamId,
  sectionId,
}) => {
  const params = new URLSearchParams();

  if (schoolId) params.append("SchoolId", schoolId);
  if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (classId) params.append("ClassId", classId);
  if (employeeId) params.append("EmployeeId", employeeId);
  if (streamId) params.append("StreamID", streamId);
  if (subStreamId) params.append("SubStreamID", subStreamId);
  if (sectionId) params.append("SectionID", sectionId);



  return commonFetch(
    `${API_URLS.GET_CUSTOM_TIMETABLE}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const deleteSubjectPeriod = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_SUBJECT_PERIOD}`, {
    method: 'DELETE',
    body: formData,
   
    requiresAuth: true,
  });
}

// export const getCustomPeriod = async (schoolID) => {
//   return commonFetch(`${API_URLS.GET_CUSTOM_PERIOD}?SchoolID=${schoolID}`, {
//     method: "GET",
//     requiresAuth: true
//   });
// };
export const getCustomPeriod = async ({
  schoolId,
  academicYearID,
  classId,
  streamId,
  subStreamId,
  sectionId,
}) => {
  const params = new URLSearchParams();

  if (schoolId) params.append("SchoolID", schoolId);
   if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (classId) params.append("ClassId", classId);
  if (streamId) params.append("StreamId", streamId);
  if (subStreamId) params.append("SubStreamId", subStreamId);
  if (sectionId) params.append("SectionId", sectionId);

  return commonFetch(
    `${API_URLS.GET_CUSTOM_PERIOD}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const addSchoolInstitute = async (formData) => {
  return commonFetch(API_URLS.ADD_SCHOOL_INSTITUTE, {
    method: "POST",
    requiresAuth: true,
    headers: {
      "accept": "*/*"
    },
    body: formData, 
  });
};

export const getSchoolInstitutes = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_SCHOOL_INSTITUTE}?SchoolID=${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const updateSchoolInstitute = async (id, formData) => {
  return commonFetch(`${API_URLS.UPDATE_SCHOOL_INSTITUTE}/${id}`, {
    method: "PUT",
    requiresAuth: true,
    headers: {
      "accept": "*/*"
    },
    body: formData, 
  });
};

export const deleteSchoolInstitute = async (instituteId, schoolId) => {
  return commonFetch(`${API_URLS.DELETE_SCHOOL_INSTITUTE}/${instituteId}?schoolId=${schoolId}`, {
    method: "DELETE",
    requiresAuth: true
  });
};
//hostel management authservice
export const SaveUpdateHostelRoomType = async (formData) => {
  return commonFetch(`${API_URLS.HOSTEL_ROOMTYPE_SAVEUPDATE}`, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const getHostelRoomType = async (schoolID) => {
  return commonFetch(`${API_URLS.HOSTEL_ROOMTYPE_GET}?SchoolID=${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const deleteHostelRoomType = async (roomTypeId, schoolId) => {
  return commonFetch(
    `${API_URLS.HOSTEL_ROOMTYPE_DELETE}?RoomTypeId=${roomTypeId}&SchoolId=${schoolId}`,
    {
      method: "DELETE",
      requiresAuth: true
    }
  );
};


export const SaveUpdateHostelOccupancy = async (formData) => {
  return commonFetch(`${API_URLS.HOSTEL_OCCUPANCY_SAVEUPDATE}`, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const getHostelOccupancy= async (schoolID) => {
  return commonFetch(`${API_URLS.HOSTEL_OCCUPANCY_GET}?SchoolID=${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const deleteHostelOccupancy = async (occupancyId, schoolId) => {
  return commonFetch(
    `${API_URLS.HOSTEL_OCCUPANCY_DELETE}?OccupancyId=${occupancyId}&SchoolId=${schoolId}`,
    {
      method: "DELETE",
      requiresAuth: true
    }
  );
};

export const SaveUpdateRoom = async (payload) => {
  return commonFetch(`${API_URLS.HOSTEL_ROOM_SAVEUPDATE}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
    requiresAuth: true,
  });
};

export const getHostelRoom= async (schoolID) => {
  return commonFetch(`${API_URLS.HOSTEL_ROOM_GET}?SchoolID=${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const HostelRoomDelete = async (roomId, schoolID, hostelId) => {
  const params = new URLSearchParams({
    SchoolId: schoolID, 
  });

  if (roomId) {
    params.append("RoomId", roomId);
  }

  if (hostelId) {
    params.append("HostelId", hostelId);
  }

  return commonFetch(
    `${API_URLS.HOSTEL_ROOM_DELETE}?${params.toString()}`,
    {
      method: "DELETE",
      requiresAuth: true
    }
  );
};

export const SaveUpdateHostelFee = async (payload) => {
  return commonFetch(`${API_URLS. HOSTELFEE_SAVEUPDATE}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
    requiresAuth: true,
  });
};

export const getHostelFee = async (schoolID, academicYearId) => {
  return commonFetch(
    `${API_URLS.HOSTELFEE_GET}?SchoolID=${schoolID}&academicYearId=${academicYearId}`,
    {
      method: "GET",
      requiresAuth: true
    }
  );
};

export const HostelFeeDelete = async (feeId) => {
  return commonFetch(
    `${API_URLS.HOSTELFEE_DELETE}?FeeId=${feeId}`,
    {
      method: "DELETE",
      requiresAuth: true
    }
  );
};

export const GetAllHostelFeeFrequncy = async () => {
  return commonFetch(`${API_URLS.HOSTELFEE_FREQUNCYNAME}`, {
   method: "GET",
    requiresAuth: true
  });
};

export const AssignRoomToStudent = async (payload) => {
  return commonFetch(API_URLS.ASSIGN_HOSTEL_TO_STUDENT, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

// export const getAssignHostel = async (schoolID, academicYearId,) => {
//   return commonFetch(
//     `${API_URLS.GET_ASSIGN_HOSTEL}?SchoolID=${schoolID}&academicYearId=${academicYearId}`,
//     {
//       method: "GET",
//       requiresAuth: true
//     }
//   );
// };
export const getAssignHostel = async (
  schoolID,
  academicYearId,
  pagenumber,
  pagesize
) => {
  const params = new URLSearchParams();

  if (schoolID) params.append("SchoolID", schoolID);
  if (academicYearId) params.append("academicYearId", academicYearId);
  if (pagenumber) params.append("PageNumber", pagenumber);
  if (pagesize) params.append("PageSize", pagesize);

  return commonFetch(
    `${API_URLS.GET_ASSIGN_HOSTEL}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const DeleteHostelAssignRoom = async (assignId) => {
  return commonFetch(
    `${API_URLS.DELETE_ASSIGN_HOSTEL}?AssignId=${assignId}`,
    {
      method: "DELETE",
      requiresAuth: true
    }
  );
};

export const GetAllDesingnation = async (formData) => {
  return commonFetch(API_URLS.CURD_DESIGNATION, {
    method: 'POST',
    body: formData,
    requiresAuth: true,
  });
};
export const CreateDesingnation = async (formData) => {
  return commonFetch(API_URLS.CURD_DESIGNATION, {
    method: 'POST',
    body: formData,
    requiresAuth: true,
  });
};
export const UpdateDesingnation = async (formData) => {
  return commonFetch(API_URLS.CURD_DESIGNATION, {
    method: 'POST',
    body: formData,
    requiresAuth: true,
  });
};
export const DeleteDesingnation = async (formData) => {
  return commonFetch(API_URLS.CURD_DESIGNATION, {
    method: 'POST',
    body: formData,
    requiresAuth: true,
  });
};

export const GetAllDefaultMenus = async (roleID,schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_DEFAULT_MENUS}?RoleID=${roleID}&SchoolID=${schoolID}`,
    {
      method: 'POST',
      requiresAuth: true,
    }
  );
};
export const GetAllDefaultMenusEmployee = async (roleID,schoolID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_DEFAULT_MENUS}?RoleID=${roleID}&SchoolID=${schoolID}`,
    {
      method: 'POST',
      requiresAuth: true,
    }
  );
};
export const GetAllAssignMenus = async (formData) => {
  return commonFetch(API_URLS.GET_ALL__ASSIGN_MENUS_AND_ROLES, {
    method: 'POST',
    body: formData,
    requiresAuth: true,
  });
};
export const InsertUpdateAssignMenus = async (payload) => {
  return commonFetch(API_URLS.INSERT_UPDATE_MENUS_TO_ROLES, {
    method: 'POST',
    body: payload,
    requiresAuth: true,
  });
};

export const saveUpdateTransportFee = async (payload) => {
  return commonFetch(API_URLS.TRANSPORT_FEE_SAVE_UPDATE, {
    method: "POST",
    body: payload,
    requiresAuth: true
  });
};

export const GetTransportFee = async (schoolID, academicYearID) => {
  const formData = new FormData();
  formData.append('SchoolId', schoolID);
  formData.append('AcademicYearID', academicYearID);
  return commonFetch(API_URLS.GET_TRANSPORT_FEE, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const deleteTransportFee = async (payload) => {
  const url = `${API_URLS.DELETE_TRANSPORT_FEE}`;
  return commonFetch(url, {
    method: "DELETE",
    requiresAuth: true,
    body: payload
  });
};

export const InsertTranportManagerStop = async (formdata) => {
  return commonFetch(`${API_URLS.TRANSPORT_MANAGER_INSERT_STOP}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const GetTransportManagerStopGetAll = async ( schoolID, academicYearID, pageNumber, pageSize ) => {
  return commonFetch(
    `${API_URLS.TRANSPORT_MANAGER_GET_STOP_GETALL}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}&PageNumber=${pageNumber}&PageSize=${pageSize}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const GetTransportManagerStopGetAllforAddStudent = async ( schoolID, academicYearID ) => {
  return commonFetch(
    `${API_URLS.TRANSPORT_MANAGER_GET_STOP_GETALL}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}&PageNumber=${1}&PageSize=${1000}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const GetTransportManagerTransportFeeApplicableFor = async ( schoolID, academicYearID ) => {
  return commonFetch(
    `${API_URLS.TRANSPORT_MANAGER_TRANSPORT_FEE_APPLICABLE_FOR}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const GetTransportManagerGetStopApplicableFor = async ( schoolID, academicYearID ) => {
  return commonFetch(
    `${API_URLS.TRANSPORT_MANAGER_GET_STOP_APPLICABLE_FOR}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const UpdateTransportManagerStop = async (payload) => {
  return commonFetch(API_URLS.TRANSPORT_MANAGER_UPDATE_STOP, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload,
    requiresAuth: true,
  });
};

export const DeleteTransportManagerStop = async (payload) => {
  const formData = new FormData();
  
  formData.append('RouteID', payload.RouteID || "");
  formData.append('StopID', payload.StopID || "");
  formData.append('SchoolID', payload.SchoolID || "");
  formData.append('AcademicYearID', payload.AcademicYearID || "");

  return commonFetch(API_URLS.TRANSPORT_MANAGER_DELETE_STOP, {
    method: 'DELETE',
    requiresAuth: true,
    body: formData, 
  });
};

export const UpdateTransportManagerStopStatus = async (formdata) => {
  return commonFetch(`${API_URLS.TRANSPORT_MANAGER_UPDATE_STOP_STATUS}`, {
    method: "PUT",
    body: formdata,
    requiresAuth: true,
  });
};

export const GetAllBulkStudentData = async (formdata) => {
  return commonFetch(`${API_URLS.GET_ALL_STUDENT_BULK_DATA}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const UpdateStudentInfo = async (payload) => {
  return commonFetch(API_URLS.UPDATE_STUDENT_DATA, {
    method: 'PUT',
    body: payload,
    requiresAuth: true,
  });
};

export const GetAllHostelFeeType = async () => {
  return commonFetch(`${API_URLS.HOSTEL_FEETYPE}`, {
   method: "GET",
    requiresAuth: true
  });
};

export const GetHostelDashboardDetails = async (schoolId, academicYearId, actionType) => {
  return commonFetch(
    `${API_URLS.HOSTEL_REPORT_DETAIL}?schoolId=${schoolId}&academicYearId=${academicYearId}&actionType=${actionType}`,
    {
      method: 'GET',
      requiresAuth: true,
    }
  );
};

export const TransportGetAllFeeType = async ( schoolID, academicYearID ) => {
  return commonFetch(
    `${API_URLS.TRANSPORT_GET_ALL_FEE_TYPE}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const saveUpdateExpense = async (payload) => {
  return commonFetch(API_URLS.EXPENSE_MASTER_POST, {
    method: "POST",
    body: payload,
    requiresAuth: true
  });
};

export const GetAllExpense = async ( schoolID, academicYearID ) => {
  return commonFetch(
    `${API_URLS.EXPENSE_MASTER_GET}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const DeleteExpense = async (expenseHeadID, schoolID) => {
  return commonFetch(
    `${API_URLS.EXPENSE_MASTER_DELETE}?expenseHeadID=${expenseHeadID}&schoolID=${schoolID}`,
    {
      method: "DELETE",
      requiresAuth: true,
    }
  );
};

export const saveUpdateExpenseHead = async (payload) => {
  return commonFetch(API_URLS.EXPENSE_HEAD_POST, {
    method: "POST",
    body: payload,
    requiresAuth: true
  });
};

export const getAllExpenseHeadList = async (
  SchoolID,
  AcademicYearID,
  ExpenseHeadID,
  FromDate,
  ToDate,
  Search,
  PageNumber,
  PageSize
) => {
  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolID", SchoolID);

  if (AcademicYearID) {
    params.append("AcademicYearID", AcademicYearID);
  }

  if (ExpenseHeadID) {
    params.append("ExpenseHeadID", ExpenseHeadID);
  }

  if (FromDate) {
    params.append("FromDate", FromDate);
  }

  if (ToDate) {
    params.append("ToDate", ToDate);
  }

  if (Search && Search.trim() !== "") {
    params.append("Search", Search);
  }

  if (PageNumber) {
    params.append("PageNumber", PageNumber);
  }

  if (PageSize) {
    params.append("PageSize", PageSize);
  }

  return commonFetch(
    `${API_URLS.EXPENSE_HEAD_GET}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const DeleteExpenseHead = async (expenseID, schoolID) => {
  return commonFetch(
    `${API_URLS.EXPENSE_HEAD_DELETE}?expenseID=${expenseID}&schoolID=${schoolID}`,
    {
      method: "DELETE",
      requiresAuth: true,
    }
  );
};



export const saveUpdateSyllabus = async (payload) => {
  return commonFetch(API_URLS.POST_UNITMASTER, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};

export const getAllUnits = async (
  schoolID,
  academicYearID,
  classID,
  streamID,
  subStreamID,
  subjectID
) => {
  const params = new URLSearchParams();

  if (schoolID) {
    params.append("schoolID", schoolID);
  }

  if (academicYearID) {
    params.append("academicYearID", academicYearID);
  }

  if (classID) {
    params.append("classID", classID);
  }

  if (streamID) {
    params.append("streamID", streamID);
  }

  if (subStreamID) {
    params.append("subStreamID", subStreamID);
  }

  if (subjectID) {
    params.append("subjectID", subjectID);
  }

  return commonFetch(
    `${API_URLS.GET_UNITMASTER}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const DeleteUnits = async (payload) => {
  return commonFetch(
    `${API_URLS.DELETE_UNITMASTER}`,
    {
      method: "DELETE",
      body: payload,
      requiresAuth: true,
    }
  );
};


export const saveUpdateSyllabusBulkUpload = async (payload) => {
  return commonFetch(API_URLS.ADD_UPDATE_BULK_SYLLABUS, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};


export const getAllSyllabus = async (
  schoolId,
  academicYearId,
  classID,
  streamID,
  subStreamID,
  subjectID,
  unitID,
  pageNumber ,
  pageSize 
) => {
  const params = new URLSearchParams();

  if (schoolId) {
    params.append("schoolId", schoolId);
  }

  if (academicYearId) {
    params.append("academicYearId", academicYearId);
  }

  if (classID) {
    params.append("classID", classID);
  }

  if (streamID) {
    params.append("streamID", streamID);
  }

  if (subStreamID) {
    params.append("subStreamID", subStreamID);
  }

  if (subjectID) {
    params.append("subjectID", subjectID);
  }

  if (unitID) {
    params.append("unitID", unitID);
  }

  if (pageNumber) {
    params.append("pageNumber", pageNumber);
  }

  if (pageSize) {
    params.append("pageSize", pageSize);
  }

  return commonFetch(
    `${API_URLS.GET_BULK_SYLLABUS}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const DeleteSyllabus = async (payload) => {
  return commonFetch(
    `${API_URLS.DELETE_BULK_SYLLABUS}`,
    {
      method: "DELETE",
      body: payload,
      requiresAuth: true,
    }
  );
};


export const GetEmployeeLeaveDashboard = async (
  schoolID,
  employeeID,
  academicYearID
) => {
  return commonFetch(
    `${API_URLS.GET_EMPLOYEE_LEAVE}?schoolId=${schoolID}&employeeID=${employeeID}&academicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getAllLeaveSummary = async (schoolID, academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_ALL_LEAVE_SUMMARY}/${schoolID}/${academicYearID}`,  
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const saveUpdateTCStudentDetails = async (payload) => {
  return commonFetch(API_URLS.SAVE_UPDATE_TC_DETAILS, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};


export const getUpdatedTcDetails = async (
  schoolId,
  academicYearId,
  genrateTCId,
  studentId,
  pageNumber ,
  pageSize 
) => {
  const params = new URLSearchParams();

  if (schoolId) {
    params.append("schoolId", schoolId);
  }

  if (academicYearId) {
    params.append("academicYearId", academicYearId);
  }

  if (genrateTCId) {
    params.append("GenrateTCId", genrateTCId);
  }

  if (studentId) {
    params.append("StudentId", studentId);
  }

  if (pageNumber) {
    params.append("pageNumber", pageNumber);
  }

  if (pageSize) {
    params.append("pageSize", pageSize);
  }

  return commonFetch(
    `${API_URLS.GET_UPDATED_TC_DETAILS}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const GetTransportFreqMaster = async (formdata) => {
  return commonFetch(`${API_URLS.GET_ALL_TRANSPORT_FREQUENCIES}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const GetAllBulkAttendanceMarksheet = async (formdata) => {
  return commonFetch(`${API_URLS.BULK_UPDATE_MARKSHEET_ATTENDANCE}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const InsertBulkAttendanceMarksheet = async (formdata) => {
  return commonFetch(`${API_URLS.BULK_UPDATE_MARKSHEET_ATTENDANCE}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const UpdateBulkAttendanceMarksheet = async (formdata) => {
  return commonFetch(`${API_URLS.BULK_UPDATE_MARKSHEET_ATTENDANCE}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const saveUpdatePayroll = async (payload) => {
  return commonFetch(API_URLS.POSTUPDATE_PAYROLL, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};

export const getAllPayrollTypes = async (
  schoolId,
  type,
) => {
  const params = new URLSearchParams();

  if (schoolId) {
    params.append("schoolId", schoolId);
  }

  if (type) {
    params.append("type", type);
  }

  return commonFetch(
    `${API_URLS.GET_ALL_PAYROLL_TYPES}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const DeletePayrollType = async (payrollTypeId) => {
  return commonFetch(
    `${API_URLS.DELETE_PAYROLL_TYPE}/${payrollTypeId}`,
    {
      method: "DELETE",
      requiresAuth: true,
    }
  );
};

export const GetAllWageType = async () => {
  return commonFetch(`${API_URLS.GET_WAGE_TYPE}`, {
   method: "GET",
    requiresAuth: true
  });
};
export const GetAllAccountType = async () => {
  return commonFetch(`${API_URLS.GET_ALL_ACCOUNT_TYPE}`, {
   method: "GET",
    requiresAuth: true
  });
};
export const GetAllPayFrequency = async () => {
  return commonFetch(`${API_URLS.GET_PAY_FREQUENCY}`, {
   method: "GET",
    requiresAuth: true
  });
};
export const GetAllWorkType = async () => {
  return commonFetch(`${API_URLS.GET_WORK_TYPE}`, {
   method: "GET",
    requiresAuth: true
  });
};
export const GetAllShift= async () => {
  return commonFetch(`${API_URLS.GET_ALL_SHIFT}`, {
   method: "GET",
    requiresAuth: true
  });
};
export const getEmployeePayslip = async (
  schoolId,
  academicYearId,
  employeeId,
  month,
  year,
  paymentStatus,
  pageNumber,
  pageSize
) => {
  const params = new URLSearchParams();

  if (schoolId) params.append("SchoolId", schoolId);
  if (academicYearId) params.append("AcademicYearId", academicYearId);
  if (employeeId) params.append("EmployeeId", employeeId);
  if (month) params.append("Month", month);
  if (year) params.append("Year", year);
  if (paymentStatus) params.append("PaymentStatus", paymentStatus);
  if (pageNumber) params.append("PageNumber", pageNumber);
  if (pageSize) params.append("PageSize", pageSize);

  return commonFetch(
    `${API_URLS.GET_ALL_EMPLOYEE_PAYSLIP}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const savePaymentprocess = async (payload) => {
  return commonFetch(API_URLS.EMPLOYEE_PAYSLIP_PAYMENT, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};
export const savePaymentPay = async (payload) => {
  return commonFetch(API_URLS.EMPLOYEE_PAYSLIP_PAYMENT_Pay, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};
export const GetEmployeePayslipList = async (
  schoolId,
  employeeId
) => {
  return commonFetch(
    `${API_URLS.EMPLOYEE_PAYSLIP_LIST}?schoolId=${schoolId}&employeeId=${employeeId}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const GetEmployeePayslipHistory = async (
  schoolId,
  month,
  year
) => {
  const params = new URLSearchParams();

  if (schoolId) params.append("schoolId", schoolId);
  if (month) params.append("month", month);
  if (year) params.append("year", year);

  return commonFetch(
    `${API_URLS.EMPLOYEE_PAYSLIP_HISTORY}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getEmployeeDOJList = async (
  schoolId,
  month,
  year,
  roleId,
  designationId,
  searchText,
  pageNumber,
  pageSize,
  sortBy
) => {
  const params = new URLSearchParams();

  if (schoolId) {
    params.append("schoolId", schoolId);
  }

  if (month) {
    params.append("month", month);
  }

  if (year) {
    params.append("year", year);
  }

  if (roleId) {
    params.append("roleId", roleId);
  }

  if (designationId) {
    params.append("designationId", designationId);
  }

  if (searchText) {
    params.append("searchText", searchText);
  }

  if (pageNumber) {
    params.append("pageNumber", pageNumber);
  }

  if (pageSize) {
    params.append("pageSize", pageSize);
  }

  if (sortBy) {
    params.append("sortBy", sortBy);
  }

  return commonFetch(
    `${API_URLS.GET_EMPLOYEE_DOJ_LIST}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const UpdateBUlkAttendance = async (payload) => {
  return commonFetch(API_URLS.STAFF_DOJ_UPDATE, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};

export const getEmployeeAdvanceSalaryList = async (
  schoolId,
  month,
  year,
  roleId,
  designationId,
  searchText,
  pageNumber,
  pageSize,
  sortBy
) => {
  const params = new URLSearchParams();

  if (schoolId) {
    params.append("schoolId", schoolId);
  }

  if (month) {
    params.append("month", month);
  }

  if (year) {
    params.append("year", year);
  }

  if (roleId) {
    params.append("roleId", roleId);
  }

  if (designationId) {
    params.append("designationId", designationId);
  }

  if (searchText) {
    params.append("searchText", searchText);
  }

  if (pageNumber) {
    params.append("pageNumber", pageNumber);
  }

  if (pageSize) {
    params.append("pageSize", pageSize);
  }

  if (sortBy) {
    params.append("sortBy", sortBy);
  }

  return commonFetch(
    `${API_URLS.GET_STAFF_ADVANCE_SALARY}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const UpdateAdvanceSalary = async (payload) => {
  return commonFetch(API_URLS.STAFF_ADVANCE_SALARY_UPDATE, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};
export const GetDueByStudentID = async (payload) => {
  return commonFetch(API_URLS.CURD_FEE_DUE, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};
export const InsertDueByStudentID = async (payload) => {
  return commonFetch(API_URLS.CURD_FEE_DUE, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};
export const UpdateDueByStudentID = async (payload) => {
  return commonFetch(API_URLS.CURD_FEE_DUE, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};
export const DeleteDueByStudentID = async (payload) => {
  return commonFetch(API_URLS.CURD_FEE_DUE, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};



export const getSubjectMaster = async (
  schoolId,
  classId,
  streamId,
  subStreamId
) => {
  const params = new URLSearchParams();

  if (schoolId) {
    params.append("SchoolID", schoolId);
  }

  if (classId) {
    params.append("ClassID", classId);
  }

  if (streamId) {
    params.append("StreamID", streamId);
  }

  if (subStreamId) {
    params.append("SubStreamID", subStreamId);
  }

  return commonFetch(
    `${API_URLS.GET_SUBJECT_MASTER}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const InsertSubject = async (payload) => {
  return commonFetch(API_URLS.INSERT_SUBJECTS, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};

export const UpdateSubject = async (payload) => {
  return commonFetch(API_URLS.UPDATE_SUBJECTS, {
    method: "PUT",
    body: payload,
    requiresAuth: true
    
  });
};

export const deleteSubject= async (formData) => {
  return commonFetch(`${API_URLS.DELETE_SUBJECTS}`, {
    method: 'DELETE',
    body: formData,
 
    requiresAuth: true,
  });
};

export const GetEmployeeByIdPayslipList = async (
  schoolId,
  employeeId,
  year
) => {
  return commonFetch(
    `${API_URLS.EMPLOYEE_BYID_PAYSLIP_LIST}?schoolId=${schoolId}&employeeId=${employeeId}&year=${year}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
    

export const GettAllEmployeeListByRole = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  return commonFetch(`${API_URLS.NOTICE_DASHBOARD_ALL_EMPLOYEE_LIST_BY_ROLE}?${queryString}`, {
    method: "GET",
    requiresAuth: true
  });
};

// export const GetAllUserByRole = async (payload) => {
//   const queryParams = new URLSearchParams(payload).toString();

//   return commonFetch(`${API_URLS.GET_ALL_USERS_BY_ROLE}?${queryParams}`, {
//     method: "GET",
//     requiresAuth: true
//   });
// };

export const GetAllUserByRole = async (payload) => {
  const cleanPayload = Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => value != null && value !== '')
  );
  
  const queryParams = new URLSearchParams(cleanPayload).toString();

  return commonFetch(`${API_URLS.GET_ALL_USERS_BY_ROLE}?${queryParams}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const InsertBulkAttendanceEmployee = async (formdata) => {
  return commonFetch(`${API_URLS.INSERT_EMPLOYEE_ATTENDANCE_BULK}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};
export const InsertBulkAttendanceStudent = async (formdata) => {
  return commonFetch(`${API_URLS.INSERT_STUDENT_ATTENDANCE_BULK}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  
  });
};

export const SaveUpdateHouse = async (formData) => {
  return commonFetch(API_URLS.SAVE_UPDATE_HOUSE,
    {
      method: "POST",
      body: formData,
      requiresAuth: true
    });
};

export const GetHouseList = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_HOUSE}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`, {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const DeleteHouse= async (houseId) => {
  return commonFetch(
    `${API_URLS.DELETE_HOUSE}?HouseId=${houseId}`,
    {
      method: "DELETE",
      requiresAuth: true
    }
  );
};

export const HouseAssign = async (payload) => {
  return commonFetch(API_URLS.ASSIGN_HOUSE, {
    method: "POST",
    body: payload,
    requiresAuth: true
    
  });
};

export const GetAssignHouseList = async ({
  houseId,
  houseAssignmentId,
  schoolId,
  academicYearId,
  pageNumber = pageNumber,
  pageSize = pageSize,
  searchText = "",
  sortBy = "",
}) => {
  const queryParams = new URLSearchParams({
    HouseId: houseId || "",
    HouseAssignmentId: houseAssignmentId || "",
    SchoolId: schoolId || "",
    AcademicYearId: academicYearId || "",
    PageNumber: pageNumber,
    PageSize: pageSize,
    SearchText: searchText,
    SortBy: sortBy,
  });

  return commonFetch(
    `${API_URLS.GET_ASSIGN_HOUSE_LIST}?${queryParams.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const DeleteHouseAssignmentStudent= async (houseId,studentID) => {
  return commonFetch(
    `${API_URLS.DELETE_ASSIGN_HOUSE_STUDENT}?HouseId=${houseId}&StudentId=${studentID}`,
    {
      method: "DELETE",
      requiresAuth: true
    }
  );
};

export const getAllEmployeeAttendenceMarkByDate = async (formData) => {
  return commonFetch(API_URLS.GETALL_EMPLOYEE_ATTENDANCE_BYDATE,
    {
      method: "POST",
      body: formData,
      requiresAuth: true
    });
};

export const InsertUpdateEmployeeAttendance = async (formData) => {
  return commonFetch(API_URLS.INSERT_UPDATE_ATTENDANCE_EMPLOYEE, {
    method: 'POST',
    body: formData,

    requiresAuth: true,
  });
};

export const getAllEmployeeAttendenceReport = async (formData) => {
  return commonFetch(API_URLS.GET_EMPLOYEES_ATTENDANCE_REPORT,
    {
      method: "POST",
      body: formData,
      requiresAuth: true
    });
};

export const GetAllStudentColoums = async () => {
  return commonFetch(`${API_URLS.GET_STUDENT_HEADER_NAME}`, {
   method: "GET",
    requiresAuth: true
  });
};

export const DeleteStudentData = async (payload) => {
  return commonFetch(API_URLS.DELETE_STUDENT_DATA, {
    method: "DELETE",
    body: payload,
    requiresAuth: true,
  });
};

export const GetFinanceSummaryReport = async ({
  schoolID,
  academicYearID,
  SelectedDate,
  SelectedDateTo,

}) => {
  const params = new URLSearchParams();

  params.append("SchoolID", schoolID);
  if (academicYearID) params.append("AcademicYearId", academicYearID);
  if (SelectedDate) params.append("SelectedDate", SelectedDate);
  if (SelectedDateTo) params.append("SelectedDateTo", SelectedDateTo);

  const url = `${API_URLS.GET_FINANCE_REPORT}?${params.toString()}`;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetDiscountStudentList = async ({
  schoolID,
  academicYearID,
  classID,
  streamID,
  subStreamID,
  sectionID,
  feeTypeID,
  pageNumber,
  pageSize,
}) => {
  const params = new URLSearchParams();

  params.append("SchoolID", schoolID);

  if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (classID) params.append("ClassID", classID);
  if (streamID) params.append("StreamID", streamID);
  if (subStreamID) params.append("SubStreamID", subStreamID);
  if (sectionID) params.append("SectionID", sectionID);
  if (feeTypeID) params.append("FeeTypeID", feeTypeID);

  if (pageNumber !== undefined && pageNumber !== null) {
    params.append("PageNumber", pageNumber);
  }

  if (pageSize !== undefined && pageSize !== null) {
    params.append("PageSize", pageSize);
  }

  const url = `${API_URLS.GET_DISCOUNTSTUDENTLIST}?${params.toString()}`;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetStudentDiscountDetails = async ({
  studentID,
  academicYearID,
  schoolID,
  feeTypeID,
  searchText,
}) => {
  const params = new URLSearchParams();

  if (studentID) params.append("StudentID", studentID);
  if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (schoolID) params.append("SchoolID", schoolID);
  if (feeTypeID) params.append("FeeTypeID", feeTypeID);
  if (searchText?.trim()) params.append("SearchText", searchText.trim());

  const url = `${API_URLS.GET_STUDENTDISCOUNTTYPELIST}?${params.toString()}`;
  
  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const getFeeReport = async (formData) => {
  return commonFetch(API_URLS.GET_RECEIPTS_DOWNLOAD, {
    method: "POST",
    requiresAuth: true,
    body: formData,
  });
};


export const SaveWhatsAppTemplate = async (formdata) => {
  return commonFetch(`${API_URLS.SAVE_WHATS_APP_TEMPLATE}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const GetWhatsUpTemplateList = async (templateName = "", schoolID = "") => {
  const params = new URLSearchParams();
  if (schoolID) params.append("SchoolID", schoolID);
  if (templateName) params.append("TemplateName", templateName);

  const queryString = params.toString();
  const url = queryString ? `${API_URLS.GET_WHATS_APP_TEMPLATE_LIST}?${queryString}` : API_URLS.GET_WHATS_APP_TEMPLATE_LIST;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};


export const GetWhatsAppValueSourceList = async (schoolId, academicYearId, actionType) => {
  return commonFetch(
    `${API_URLS.GET_WHATS_APP_VALUE_SOURCE_LIST}`,
    {
      method: 'GET',
      requiresAuth: true,
    }
  );
};

export const SchoolWhatsAppTemplateToggle = async (payload) => {
  return commonFetch(`${API_URLS.SCHOOL_WHATS_APP_TEMPLATE_TOGGLE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const InsertUpdateWhatsAppMessageSetting = async (formdata) => {
  return commonFetch(`${API_URLS.INSERT_UPDATE_WHATS_APP_MESSAGE_SETTING}`, {
    method: "POST",
    body: formdata,
    requiresAuth: true,
  });
};

export const GetAllWahtsAppMessageSetting = async (schoolId) => {
  let url = API_URLS.GET_ALL_WHATS_APP_MESSAGE_SETTING;
  if (schoolId) {
    url += `?SchoolID=${schoolId}`;
  }
  
  return commonFetch(url, {
    method: 'GET',
    requiresAuth: true,
  });
};

export const DeleteWhatsAppTemplate = async (payload) => {
  return commonFetch(`${API_URLS.DELETE_WHATS_APP_TEMPLATE}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: payload,
    requiresAuth: true,
  });
};

export const InsertUpdateTranferStudentSchool = async (payload) => {
  return commonFetch(`${API_URLS.INSERT_TRANSFER_STUDENT_SCHOOL}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const TransferWallet = async (payload) => {
  return commonFetch(`${API_URLS.TRANSFER_WALLET}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetBirthdayList = async ({
  loginUserId,
  userRole,
  schoolId,
  academicYearId,
  filterType,
  searchText,
  pageNumber = 1,
  pageSize = 100,
}) => {
  const params = new URLSearchParams();

  if (loginUserId) params.append("LoginUserId", loginUserId);
  if (userRole) params.append("UserRole", userRole);
  if (schoolId) params.append("SchoolId", schoolId);
  if (academicYearId) params.append("AcademicYearId", academicYearId);
  if (filterType) params.append("FilterType", filterType);
  if (searchText?.trim()) params.append("SearchText", searchText.trim());

  params.append("PageNumber", pageNumber);
  params.append("PageSize", pageSize);

  const url = `${API_URLS.GET_BIRTHDAY_LIST}?${params.toString()}`;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};
export const GetLoginBirthdayMessage = async ({
  userId,
  userRole,
  schoolId,
}) => {
  const params = new URLSearchParams();

  if (userId) params.append("UserId", userId);
  if (userRole) params.append("UserRole", userRole);
  if (schoolId) params.append("SchoolId", schoolId);

  const url = `${API_URLS.GET_BIRTHDAY_MESSAGE_LIST}?${params.toString()}`;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const InsertUpdateDeleteAdmitCard = async (formData) => {
  return commonFetch(`${API_URLS.INSERT_UPDATE_DELETE_ADMIT_CARD}`, {
    method: "POST",
    requiresAuth: true,
    body: formData,
  });
};
export const InsertUpdateDeleteInstruction = async (formData) => {
  return commonFetch(`${API_URLS.MANAGE_INSTRUCTIONS_IN_ADMITCARD}`, {
    method: "POST",
    requiresAuth: true,
    body: formData,
  });
};

export const GetAdmitCardList = async ({
  Action,
  AdmitCardScheduleID,
  ExamID,
  ClassID,
  StreamID,
  SubStreamID,
  AcademicYearID,
  SchoolID,
}) => {
  const params = new URLSearchParams();

  if (Action) params.append("Action", Action);
  if (AdmitCardScheduleID)
    params.append("AdmitCardScheduleID", AdmitCardScheduleID);
  if (ExamID) params.append("ExamID", ExamID);
  if (ClassID) params.append("ClassID", ClassID);
  if (StreamID) params.append("StreamID", StreamID);
  if (SubStreamID) params.append("SubStreamID", SubStreamID);
  if (AcademicYearID)
    params.append("AcademicYearID", AcademicYearID);
  if (SchoolID) params.append("SchoolID", SchoolID);

  const url = `${API_URLS.GET_ADMIT_CARD_SCHEDULE}?${params.toString()}`;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetInstructions = async ({
  Action,
  InstructionID,
  ExamID,
  AcademicYearID,
  SchoolID,
}) => {
  const params = new URLSearchParams();

  if (Action) params.append("Action", Action);
  if (InstructionID) {
    params.append("InstructionID", InstructionID);
  }
  if (ExamID ) {
    params.append("ExamID", ExamID);
  }
  if (AcademicYearID) params.append("AcademicYearID", AcademicYearID);
  if (SchoolID) params.append("SchoolID", SchoolID);

  const url = `${API_URLS.GET_INSTRUCTIONS_IN_ADMITCARD}?${params.toString()}`;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};


export const GetAdmitCardExamList = async (payload) => {
  return commonFetch(`${API_URLS.GET_ADMIT_CARD_EXAMLIST}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
export const GetAdmitCardData = async (payload) => {
  return commonFetch(`${API_URLS.GET_ADMIT_CARD_DATA}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const UpdateMultipleFeeCollection = async (payload) => {
  if (!payload.schoolID) {
    throw new Error("schoolID is required in the payload");
  }

  const url = `${API_URLS.UPDATE_MULTIPLE_FEE_COLLECTION_APIURL}/${payload.schoolID}`;

  return commonFetch(url, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const VerifyAdminPassword = async (payload) => {
  return commonFetch(API_URLS.VERIFY_ADMIN_PASSWORD, {
    method: "POST",
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    requiresAuth: true,
  });
};

export const GetStudentDistribution = async ({
  Action,
  SchoolID,
  AcademicYearID,
  ClassID,
}) => {
  const params = new URLSearchParams();

  if (Action) params.append("Action", Action);
  if (SchoolID) params.append("SchoolID", SchoolID);
  if (AcademicYearID) params.append("AcademicYearID", AcademicYearID);
  if (ClassID) params.append("ClassID", ClassID);

  return commonFetch(`${API_URLS.GET_STUDENT_DISTRIBUTION}?${params.toString()}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetStudentAdmitCardData = async (payload) => {
  return commonFetch(`${API_URLS.GET_STUDENT_ADMIT_CARD}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
export const GetTransferredStudentsBySchool = async (params) => {
  const { SchoolID, AcademicYearID, PageNumber = 1, PageSize = 10 } = params;
  
  return commonFetch(
    `${API_URLS.GET_TRANSFERRED_STUDENTS_BY_SCHOOL}?SchoolID=${SchoolID}&AcademicYearID=${AcademicYearID}&PageNumber=${PageNumber}&PageSize=${PageSize}`,
    {
      method: 'GET',
      requiresAuth: true,
    }
  );
};

export const DownloadAdmitCard = async (payload) => {
  return commonFetch(`${API_URLS.DOWNLOAD_ADMITCARD}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getTeacherAttendancePunchReport = async (params = {}) => {
  const query = new URLSearchParams();

  // required
  if (params.schoolID)       query.append("SchoolID", params.schoolID);
  if (params.academicYearID) query.append("AcademicYearID", params.academicYearID);

  // optional filters
  if (params.roleID)         query.append("RoleID", params.roleID);
  if (params.designationID)  query.append("DesignationID", params.designationID);
  if (params.fromDate)       query.append("FromDate", params.fromDate);
  if (params.toDate)         query.append("ToDate", params.toDate);
  if (params.searchText)     query.append("SearchText", params.searchText);


  query.append("PageNumber", params.pageNumber ?? 1);
  query.append("PageSize", params.pageSize ?? 10);

  return commonFetch(
    `${API_URLS.GET_TEACHER_ATTENDANCE_PUNCH_REPORT}?${query.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const getCertificateTemplates = async (schoolID, academicYearID) => {
  return commonFetch(
    `${API_URLS.GET_CERTIFICATE_TEMPLATES}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const updateCertificateTitle = async (formData) => {
  return commonFetch(API_URLS.UPDATE_CERTIFICATE_TITLE, {
    method: "PUT",
    body: formData,
    requiresAuth: true,
  });
};

export const getCertificatePrintData = async (schoolID, academicYearID, certificateID, studentIDs = []) => {
  const params = new URLSearchParams();
  if (schoolID) params.append("SchoolID", schoolID);
  if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (certificateID) params.append("CertificateID", certificateID);
  studentIDs.forEach((id) => params.append("StudentIDs", id));

  return commonFetch(`${API_URLS.GET_CERTIFICATE_PRINT_DATA}?${params.toString()}`, {
    method: "GET",
    requiresAuth: true,
  });
};


export const issueCertificate = async (payload) => {
  return commonFetch(`${API_URLS.ISSUE_CERTIFICATE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getMyCertificates = async (schoolID, academicYearID, studentID) => {
  const params = new URLSearchParams();
  if (schoolID) params.append("SchoolID", schoolID);
  if (academicYearID) params.append("AcademicYearID", academicYearID);
  if (studentID) params.append("StudentID", studentID);
 
  return commonFetch(`${API_URLS.GET_MY_CERTIFICATES}?${params.toString()}`, {
    method: "GET",
    requiresAuth: true,
  });
};
 


export const getAdmitCardList = async (studentID,schoolID, academicYearID) => {
  const params = new URLSearchParams();
  if (studentID) params.append("StudentID", studentID);
  if (schoolID) params.append("SchoolID", schoolID);
  if (academicYearID) params.append("AcademicYearID", academicYearID);
 
  return commonFetch(`${API_URLS.GET_ADMIT_CARD_LIST}?${params.toString()}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetExamTimeTableList = async ({
  ListType,
  SchoolID,
  AcademicYearID,
  ClassID,
  StreamID,
  SubStreamID,
  Term,
}) => {
  const params = new URLSearchParams();

  if (ListType) params.append("ListType", ListType);
  if (SchoolID) params.append("SchoolId", SchoolID);
  if (AcademicYearID) params.append("AcademicYearID", AcademicYearID);
  if (ClassID) params.append("ClassID", ClassID);
  if (StreamID) params.append("StreamID", StreamID);
  if (SubStreamID) params.append("SubStreamID", SubStreamID);
  if (Term) params.append("Term", Term);

  const url = `${API_URLS.GET_Exam_TimeTable_LIST}?${params.toString()}`;

  return commonFetch(url, {
    method: "GET",
    requiresAuth: true,
  });
};

export const GetPublishedExamTimeTableList = async (payload) => {
  return commonFetch(`${API_URLS.GET_PUBLISHED_EXAM_LIST_FOR_STUDENT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetPublishedExamList = async (payload) => {
  return commonFetch(`${API_URLS.GET_PUBLISHED_EXAM_LIST}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const InsertUpdateExamPublishStatus = async (payload) => {
  return commonFetch(`${API_URLS.INSERT_UPDATE_EXAM_PUBLISH_STATUS}`, {
    method: "PUT",
    body: payload,
    requiresAuth: true,
  });
};

export const GetPublishedStudentReportCard = async ({
  SectionID,
  Term,
  SchoolID,
  ClassID,
  TemplateID,
  StudentID,
  ExamID,
  StreamID,
  SubStreamID,
  AcademicYearID,
}) => {
  const formData = new FormData();
  formData.append("SectionID", SectionID ?? "");
  formData.append("Term", Term ?? "");
  formData.append("SchoolID", SchoolID ?? "");
  formData.append("ClassID", ClassID ?? "");
  formData.append("TemplateID", TemplateID ?? "");
  formData.append("StudentID", StudentID ?? "");
  formData.append("ExamID", ExamID ?? "");
  formData.append("StreamID", StreamID ?? "");
  formData.append("SubStreamID", SubStreamID ?? "");
  formData.append("AcademicYearID", AcademicYearID ?? "");

  return commonFetch(API_URLS.GET_PUBLISHED_STUDENT_REPORT_CARD, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const ReceivePettyCash = async (formData) => {
  return commonFetch(`${API_URLS.INSERT_UPDATE_RECEIVE_PETTY_CASH}`, {
    method: "POST",
    requiresAuth: true,
    body: formData,
  });
};


export const GetReceivePettyCash = async ({
  SchoolID,
  AcademicYearID,
  PettyCashReceiptID,
  PageNumber,
  PageSize,
}) => {
  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolID", SchoolID);
  if (AcademicYearID) params.append("AcademicYearID", AcademicYearID);
  if (PettyCashReceiptID) params.append("PettyCashReceiptID", PettyCashReceiptID);
  if (PageNumber !== undefined && PageNumber !== null)
    params.append("PageNumber", PageNumber);
  if (PageSize !== undefined && PageSize !== null)
    params.append("PageSize", PageSize);

  return commonFetch(
    `${API_URLS. GET_RECEIVE_PETTY_CASH}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const DeleteReceivePettyCash = async (formData) => {
  return commonFetch(`${API_URLS.DELETE_RECEIVE_PETTY_CASH}`, {
    method: "DELETE",
    requiresAuth: true,
    body: formData,
  });
};

export const GetLedgerSummery = async ({
  SchoolID,
  AcademicYearID,
  FromDate,
  ToDate,
  VoucherType,
  PaymentMode,
  Search,
  PageNumber,
  PageSize,
}) => {
  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolID", SchoolID);
  if (AcademicYearID) params.append("AcademicYearID", AcademicYearID);
  if (FromDate) params.append("FromDate", FromDate);
  if (ToDate) params.append("ToDate", ToDate);
  if (VoucherType) params.append("VoucherType", VoucherType);
  if (PaymentMode) params.append("PaymentMode", PaymentMode);
  if (Search) params.append("Search", Search);

  if (PageNumber !== undefined && PageNumber !== null) {
    params.append("PageNumber", PageNumber);
  }

  if (PageSize !== undefined && PageSize !== null) {
    params.append("PageSize", PageSize);
  }

  return commonFetch(
    `${API_URLS. GET_LEDGER_SUMMERY}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const GetExpenseByHead = async ({
  SchoolID,
  AcademicYearID,
  SelectedDate,
  SelectedDateTo,
}) => {
  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolID", SchoolID);
  if (AcademicYearID) params.append("AcademicYearID", AcademicYearID);
  if (SelectedDate) params.append("SelectedDate", SelectedDate);
  if (SelectedDateTo) params.append("SelectedDateTo", SelectedDateTo);

  return commonFetch(
    `${API_URLS.GET_EXPENSE_BY_HEAD}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const GetPettyCashDashboardData = async ({
  SchoolID,
  AcademicYearID,
}) => {
  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolID", SchoolID);
  if (AcademicYearID) params.append("AcademicYearID", AcademicYearID);
  return commonFetch(
    `${API_URLS.GET_PETTY_CASH_DASHBOARD}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};
export const GetCashClosingData = async ({
  SchoolID,
  AcademicYearID,
  ClosingDate
}) => {
  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolID", SchoolID);
  if (AcademicYearID) params.append("AcademicYearID", AcademicYearID);
  if (ClosingDate) params.append("ClosingDate", ClosingDate);
  return commonFetch(
    `${API_URLS.GET_CASH_CLOSINGBYALLDATE}?${params.toString()}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const ManageCashClosing = async (formData) => {
  return commonFetch(`${API_URLS.INSERT_MANAGECASHCLOSING}`, {
    method: "POST",
    requiresAuth: true,
    body: formData,
  });
};



export const GetPettyCashBalance = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_PETTYCASH_BALANCE}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`, {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const GetPettyCashReceivedByList = async (schoolID, FieldType) => {
  return commonFetch(`${API_URLS.GET_PETTYCASH_RECEIVED_BY_LIST}?SchoolID=${schoolID}&FieldType=${FieldType}`, {
      method: "GET",
      requiresAuth: true,
    }
  );
};

export const GetCashReportList = async ({
  SchoolID,
  AcademicYearID,
  ReportType,
  ReportDate,
  FromMonth,
  ToMonth,
  Cashier,
  PaymentMode,
  ExpenseHeadID,
  PageNumber,
  PageSize,
  SearchText,
}) => {
  const params = new URLSearchParams();

  const appendParam = (key, value) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  };

  appendParam("SchoolID", SchoolID);
  appendParam("AcademicYearID", AcademicYearID);
  appendParam("ReportType", ReportType);
  appendParam("ReportDate", ReportDate);
  appendParam("FromMonth", FromMonth);
  appendParam("ToMonth", ToMonth);
  appendParam("Cashier", Cashier);
  appendParam("PaymentMode", PaymentMode);
  appendParam("ExpenseHeadID", ExpenseHeadID);
  appendParam("PageNumber", PageNumber);
  appendParam("PageSize", PageSize);
  appendParam("SearchText", SearchText);

  const queryString = params.toString();

  return commonFetch(
    `${API_URLS.GET_PETTYCASH_REPORT_LIST}${queryString ? `?${queryString}` : ""}`,
    {
      method: "GET",
      requiresAuth: true,
    }
  );
};


export const getBusHistory = async (schoolId, busId, fromDate, toDate, academicYearId) => {
  return commonFetch(
    `${API_URLS.GET_BUS_HISTORY}?schoolId=${schoolId}&busId=${busId}&fromDate=${encodeURIComponent(
      fromDate
    )}&toDate=${encodeURIComponent(toDate)}&academicYearId=${academicYearId}`,
    {
      method: 'GET',
      requiresAuth: true,
    }
  );
};

export const getBusDetails = async (schoolId, vehicleId) => {
  return commonFetch(`${API_URLS.GET_BUS_DETAILS}/${schoolId}/${vehicleId}`, {
    method: 'GET',
    requiresAuth: true,
  });
};

export const getSchoolLocationById = async schoolID => {
  return commonFetch(`${API_URLS.GET_SCHOOL_LOCATION_BY_ID}?SchoolID=${schoolID}`, {
    method: 'GET',
    requiresAuth: true,
  })
}


export const DownloadExamTimeTable = async (payload) => {
  
  return commonFetch(`${API_URLS.DOWNLOAD_EXAM_TIMETABLE}`,{
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const BulkCoScholasticMarksExcelDownload = async (data) => {
  return commonFetch(`${API_URLS.BULKCOSCHOLASTICMARKSEXCELDOWNLOAD}`, {
    method: "POST",
    body: data,
    requiresAuth: true,
  });
};

// export const BulkCoScholasticMarksExcelDownload = async (data) => {
//   const token = localStorage.getItem('token');
//   const endpoint = API_URLS.BULKCOSCHOLASTICMARKSEXCELDOWNLOAD;
//   const response = await fetch(`${configAPI.REACT_APP_API_BASE_URL}api/v1/${endpoint}`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       "Authorization": `Bearer ${token}`
//     },
//     body: JSON.stringify(data),
//   });
//   if (!response.ok) {
//     throw new Error("Failed to download Excel file");
//   }
//   return await response.blob();
// };

export const BulkMarksExcelDownload = async (data) => {
  const token = localStorage.getItem('token');
  const endpoint = API_URLS.BULKEXAMMARKSEXCELDOWNLOAD;
  const response = await fetch(`${configAPI.REACT_APP_API_BASE_URL}api/v1/${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error("Failed to download Excel file");
  }
  return await response.blob();
};

export const BulkExamMarksUpload = async (formData) => {
  return commonFetch(`${API_URLS.BULKEXAMMARKSEXCELUPLOAD}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const BulkCoScholasticExamMarksUpload = async (formData) => {
  return commonFetch(`${API_URLS.BULKCOSCHOLASTICMARKSEXCElUPLOAD}`, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const ManageStudentStatus = async (payload) => {
  
  return commonFetch(`${API_URLS.MANAGE_STUDENT_STATUS}`,{
      method: "POST",
      body: payload,
      requiresAuth: true,
    }
  );
};
export const DeleteStaffData = async (payload) => {
  return commonFetch(API_URLS.DELETE_STAFF_DATA, {
    method: "DELETE",
    body: payload,
    requiresAuth: true,
  });
};
export const GetStaffDeletionImpact = async (payload) => {
  return commonFetch(API_URLS.GET_STAFF_DELETION_IMPACT, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
export const  ManageStaffStatus= async (payload) => {
  return commonFetch(API_URLS.MANAGE_STAFF_STATUS, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getCoScholasticResultByExam = async (payload) => {
  return commonFetch(
    `${API_URLS.GET_CO_SCHOLASTIC_RESULT_BY_EXAM}`,
    {
      method: "Post",
      body: payload,
      requiresAuth: true,
    }
  );
};

export const addUpdateCoScholasticExamBulk = async (payload) => {
  return commonFetch(`${API_URLS.ADD_UPDATE_CO_SCHOLASTIC_EXAM_BULK}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetExamReportResultByExam = async (payload) => {
  return commonFetch(`${API_URLS.GET_EXAM_RESULT_REPORT_BY_EXAM}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  
  });
};

export const getExamMappedListMarksheetSettings = async (schoolID, academicYearID, classID) => {
  return commonFetch(`${API_URLS.GETALL_EXAM_MAPPING}/${schoolID}?classID=${classID}&AcademicYearID=${academicYearID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const getSubjectMappingByClassStreamSubStream = async (formData) => {
  return commonFetch(API_URLS.GET_SUBJECTS_MAPPING_BY_CLASS_STREAM_SUBSTREAM, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const saveStudentSubjectMapping = async (formData) => {
  return commonFetch(API_URLS.SAVE_STUDENT_SUBJECT_MAPPING, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const getClassStudentSubjectMapping = async (schoolID, academicYearID, classID, studentID, resultFormatId) => {
  return commonFetch(`${API_URLS.GET_CLASS_STUDENT_SUBJECT_MAPPING}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}&classID=${classID}&StudentID=${studentID}${resultFormatId ? `&ResultFormatId=${resultFormatId}` : ''}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const getAllResultFormat = async () => {
  return commonFetch(`${API_URLS.GET_ALL_RESULT_FORMAT}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const getMarksheetFields = async () => {
  return commonFetch(`${API_URLS.GET_MARKSHEET_FIELDS}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const AddOrUpdateMarksheetSetting = async (formData) => {
  return commonFetch(API_URLS.ADD_OR_UPDATE_MARKSHEET_SETTING, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const getMarksheetSettings = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_MARKSHEET_SETTINGS}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const SaveExamMarksheetSetting = async (formData) => {
  return commonFetch(API_URLS.SAVE_EXAM_MARKSHEET_SETTING, {
    method: "POST",
    body: formData,
    requiresAuth: true
  });
};

export const getExamMarksheetSettings = async (schoolID, academicYearID, classID) => {
  return commonFetch(`${API_URLS.GET_EXAM_MARKSHEET_SETTING}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}&ClassID=${classID}`, {
    method: "GET",
    requiresAuth: true
  });
};


export const getStudentTripList = async ({
  VehicleID,
  DriverID,
  SchoolID,
  AcademicYearID,
  TripDate,
}) => {
  const params = new URLSearchParams({
    VehicleID,
    DriverID,
    SchoolID,
    AcademicYearID,
    TripDate,
  });

  return commonFetch(
    `${API_URLS.GET_STUDENT_TRIP_LIST}?${params.toString()}`,
    {
      method: 'GET',
      requiresAuth: true,
    }
  );
};


export const Admin2FARequest = async (payload) => {
  return commonFetch(`${API_URLS.TWO_STEP_AUTHENTICATION_REQUEST_ADMIN}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
export const Admin2FAConfirm = async (payload) => {
  return commonFetch(`${API_URLS. TWO_STEP_AUTHENTICATION_CONFIRM_ADMIN}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const Employee2FARequest = async (payload) => {
  return commonFetch(`${API_URLS.TWO_STEP_AUTHENTICATION_REQUEST_EMPLOYEE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
export const Employee2FAConfirm = async (payload) => {
  return commonFetch(`${API_URLS. TWO_STEP_AUTHENTICATION_CONFIRM_EMPLOYEE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const Parent2FARequest = async (payload) => {
  return commonFetch(`${API_URLS.TWO_STEP_AUTHENTICATION_REQUEST_PARENT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
export const Parent2FAConfirm = async (payload) => {
  return commonFetch(`${API_URLS. TWO_STEP_AUTHENTICATION_CONFIRM_PARENT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};



export const Student2FARequest = async (payload) => {
  return commonFetch(`${API_URLS.TWO_STEP_AUTHENTICATION_REQUEST_STUDENT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
export const Student2FAConfirm = async (payload) => {
  return commonFetch(`${API_URLS. TWO_STEP_AUTHENTICATION_CONFIRM_STUDENT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

//otp verification of 2FA

export const Student2FAOtpVerify = async (payload) => {
  return commonFetch(`${API_URLS.TWO_STEP_AUTHENTICATION_OTP_VERIFY_STUDENT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
export const Parent2FAOtpVerify = async (payload) => {
  return commonFetch(`${API_URLS.TWO_STEP_AUTHENTICATION_OTP_VERIFY_PARENT}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
export const Employee2FAOtpVerify = async (payload) => {
  return commonFetch(`${API_URLS. TWO_STEP_AUTHENTICATION_OTP_VERIFY_EMPLOYEE}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};
export const Admin2FAOtpVerify = async (payload) => {
  return commonFetch(`${API_URLS.TWO_STEP_AUTHENTICATION_OTP_VERIFY_ADMIN}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetMarksheetHeaderFields = async () => {
  return commonFetch(`${API_URLS.GET_MARKSHEET_HEADER_FIELDS}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const AddOrUpdateMarksheetHeaderFields = async (payload) => {
  return commonFetch(`${API_URLS.ADD_OR_UPDATE_MARKSHEET_HEADER_FIELDS}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getMarksheetHeaderFieldSettings = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_MARKSHEET_HEADER_FIELDS_SETTING}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`, {
    method: "GET",
    requiresAuth: true
  });
};
export const UpdateStudentListHeader = async (payload) => {
  return commonFetch(`${API_URLS.ADD_OR_UPDATE_STUDENT_LIST_HEADER_FIELDS}`, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const getStudentListDynamicsHeader = async (schoolID) => {
  return commonFetch(`${API_URLS.GET_STUDENT_LIST_HEADER_FIELDS}/${schoolID}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const GetResultFields = async () => {
  return commonFetch(API_URLS.GET_RESULT_FIELD, {
    method: "GET",
    requiresAuth: true,
  });
};

export const AddOrUpdateResultSetting = async (formData) => {
  return commonFetch(API_URLS.ADD_OR_UPDATE_RESULT_SETTING, {
    method: "POST",
    body: formData,
    requiresAuth: true,
  });
};

export const getResultSettings = async (schoolID, academicYearID) => {
  return commonFetch(`${API_URLS.GET_RESULT_SETTINGS}?SchoolID=${schoolID}&AcademicYearID=${academicYearID}`, {
    method: "GET",
    requiresAuth: true,
  });
};

export const ToggleManualSubjectFlag = async (payload) => {
  return commonFetch(API_URLS.TOGGLE_MANUAL_SUBJECT_FLAG, {
    method: "POST",
    body: payload,
    requiresAuth: true,
  });
};

export const GetManualSubjectFlag = async ({ SchoolID, AcademicYearID, ExamID, ClassID, StreamID, SubStreamID, SectionID }) => {
  const params = new URLSearchParams();

  if (SchoolID) params.append("SchoolID", SchoolID);
  if (AcademicYearID) params.append("AcademicYearID", AcademicYearID);
  if (ExamID) params.append("ExamID", ExamID);
  if (ClassID) params.append("ClassID", ClassID);
  if (StreamID) params.append("StreamID", StreamID);
  if (SubStreamID) params.append("SubStreamID", SubStreamID);
  if (SectionID) params.append("SectionID", SectionID);

  return commonFetch(`${API_URLS.GET_MANUAL_SUBJECT_FLAG}?${params.toString()}`, {
    method: "GET",
    requiresAuth: true
  });
};